<template>
  <div>
    <fullscreen ref="fullscreen" @change="fullscreenChange">
      <v-snackbar bottom v-model="snackbar">
        {{ text }}
        <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
      <div>
        <v-layout justify-right wrap>
          <v-flex xs12>
            <!-- :center="{lat: 1.38, lng: 103.8}" -->

            <gmap-map
              ref="mapRef"
              :center="center"
              :zoom="zoom"
              :map-type-id="mapType"
              :options="{
                styles: myStyles,
                streetViewControl: false,
                fullscreenControl: false,
                zoomControl: false,
                mapTypeControl: false,
                draggableCursor: isEditing || isPlotting ? 'crosshair' : '',
              }"
              @click="
                isPlotting || plottingImageOverlay
                  ? plotPositions($event)
                  : lineOfSightTest
                  ? testLOS($event)
                  : null
              "
              :style="[
                {
                  width: '100%',
                  height: fullscreen ? '100vh' : '92vh',
                },
              ]"
            >
              <!-- <div id="fixdiv"> -->
              <div
                :key="imageOverlayKey"
                v-if="showOverlays && overlayImages.length > 0"
              >
                <ground-overlay
                  v-for="overlay in overlayImages"
                  :key="overlay.id"
                  :source="overlay.img"
                  :bounds="overlay.bounds"
                  :opacity="0.3"
                >
                </ground-overlay>
              </div>

              <ground-overlay
                v-if="newImageOverlay && newImageOverlay.bounds"
                :key="imageOverlayKey"
                :source="newImageOverlay.img"
                :bounds="newImageOverlay.bounds"
                :opacity="0.7"
              >
              </ground-overlay>
              <gmap-rectangle
                v-if="newImageOverlay && newImageOverlay.bounds"
                :bounds="newImageOverlay.bounds"
                :key="imageOverlayKey"
                :editable="plottingImageOverlay"
                :draggable="true"
                :visible="true"
                :options="{
                  fillColor: 'white',
                }"
                @bounds_changed="addPolyBounds($event)"
              ></gmap-rectangle>
              <div v-if="showOverlayRectangles && isEditing">
                <gmap-rectangle
                  ref="rectangleRef"
                  v-for="overlay in overlayImages"
                  :key="overlay.id"
                  :bounds="overlay.bounds"
                  :editable="true"
                  :draggable="true"
                  :visible="true"
                  :options="{
                    fillColor: 'white',
                  }"
                  @dragstart="rectangeDragStart($event)"
                  @bounds_changed="updateRectangleBounds($event, overlay)"
                  @dragend="updateRectangleDragend($event, overlay)"
                ></gmap-rectangle>
              </div>

              <!-- <gmap-polygon
                :paths="imageBounds"
                :options="{
                  fillOpacity: 0.3,
                  strokeWeight: 2
                }"
                :draggable="true"
                :editable="true"
                @paths_changed="getPolyBounds($event)"
              ></gmap-polygon> -->
              <!-- New Data -->

              <!-- <gmap-polygon
                :paths="
                  newGisData
                    .filter((x) => x.type == 'Polygon')
                    .map((x) => x.data)
                "
                :options="{
                  strokeColor: activePointType.colour,
                  fillOpacity: 0.3,
                  strokeWeight: 2,
                  fillColor: activePointType.colour,
                }"
                :draggable="isPlotting"
                :editable="isPlotting"
                @click="addPosition($event)"
                @paths_changed="updatePolyData($event)"
              ></gmap-polygon> -->
              <div v-if="lineOfSightItem.length > 0">
                <gmap-polyline
                  v-for="line in lineOfSightItem"
                  :path="line.line"
                  :key="line.distance"
                  :options="{
                    strokeColor: line.success ? '#99cc33' : 'red',
                  }"
                >
                </gmap-polyline>
                <!-- <gmap-circle
              v-for="circle in lineOfSightItem"
              :center="circle.line[0]"
              :key="circle.distance"
              :radius="5000"
              :options="{
                  strokeColor: circle.success ? '#99cc33' : 'red',
                }"
              ></gmap-circle> -->
              </div>
              <gmap-polyline
                v-for="(line, index) in newGisData.filter(
                  (x) => x.type == 'Line'
                )"
                :key="
                  line.data.length > 0
                    ? typeof line.data[line.data.length - 1].lat == 'function'
                      ? line.data[line.data.length - 1].lat()
                      : line.data[line.data.length - 1].lat
                    : index
                "
                :path="line.data"
                :options="{
                  strokeColor:
                    newGisData.length > 0
                      ? line.colour
                      : activePointType.colour,
                }"
                style="z-index: 100 !important"
                :draggable="false"
                :editable="isEditing"
                @path_changed="
                  isPlotting ? updateNewLineData($event, line) : null
                "
              ></gmap-polyline>

              <!-- Existing Data -->
              <div :key="filterKey">
                <div>
                  <gmap-custom-marker
                    v-for="marker in newGisData.filter(
                      (x) => x.type == 'Point'
                    )"
                    :key="marker.id"
                    :marker="marker.position ? marker.position : marker.data[0]"
                    :clickable="isPlotting"
                    :draggable="isPlotting"
                    :label="marker.name"
                    :offsetX="-10"
                    :offsetY="17.5"
                    :icon="{ scaledSize: { width: 10, height: 10 } }"
                  >
                    <v-icon :color="marker.colour">{{ marker.icon }}</v-icon>
                  </gmap-custom-marker>
                </div>

                <div>
                  <div>
                    <cluster
                      :options="{
                        styles: [{ textColor: '#ffffff', textSize: 14 }],
                      }"
                      @click="
                        !isPlotting
                          ? (showCluster($event),
                            (isPlotting = false),
                            (isEditing = false),
                            (activePointType = {}))
                          : null
                      "
                      @contextmenu.native="rightClickHandler($event, data)"
                    >
                      <gmap-custom-marker
                        v-for="marker in markerArray"
                        :offsetY="15"
                        :key="marker.id"
                        :marker="{ lat: marker.lat, lng: marker.lng }"
                        :clickable="true"
                        :draggable="isEditing"
                        class="z-index: 5"
                        @click.native="
                          !isPlotting
                            ? showMarkerInfo(marker)
                            : addNewMarkerGisDataPoint(marker)
                        "
                        @contextmenu.native="rightClickHandler($event, marker)"
                      >
                        <v-icon
                          :class="[
                            { selected: editItem && editItem.id == marker.id },
                            'outlined',
                          ]"
                          :color="marker.gisPointType.colour"
                          >{{ marker.gisPointType.icon }}</v-icon
                        >
                        <v-flex xs12 v-if="showMarkerLabels">
                          <v-card flat color="white">
                            <span>{{ marker.name }}</span>
                          </v-card>
                        </v-flex>
                      </gmap-custom-marker>
                    </cluster>
                  </div>
                  <!-- <div v-else >
                      <gmap-custom-marker
                      v-for="marker in markerArray.filter((x) =>
                        bounds.contains({ lat: x.lat, lng: x.lng })
                      )"
                      :offsetY="15"
                      :key="marker.id"
                      :marker="{ lat: marker.lat, lng: marker.lng }"
                      :clickable="true"
                      :draggable="isEditing"
                      alignment="center"
                      class="z-index: 5"
                      @click.native="
                        !isPlotting ? showMarkerInfo(marker) : null
                      "
                      @contextmenu.native="rightClickHandler($event, marker)"
                    >
                      <v-layout justify-center align-center wrap>
                        <v-flex xs12>
                          <v-icon
                            :class="[
                              {
                                selected: editItem && editItem.id == marker.id,
                              },
                              'outlined',
                            ]"
                            :color="marker.gisPointType.colour"
                            >{{ marker.gisPointType.icon }}</v-icon
                          >
                        </v-flex>
                        <v-flex xs12 v-if="showMarkerLabels">
                          <v-card flat color="white">
                            <span>{{ marker.name }}</span>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </gmap-custom-marker>
                    </div> -->

                  <gmap-info-window
                    v-if="rightClickWindow"
                    :options="infoOptions"
                    :position="rightClickWindowData.center"
                    :opened="rightClickWindow"
                    @closeclick="rightClickWindow = false"
                  >
                    <v-card flat color="white" v-if="rightClickWindowData">
                      <v-card-title class="grey--text">{{
                        rightClickWindowData.name
                      }}</v-card-title>
                      <v-layout justify-center align-center wrap>
                        <v-btn round color="light-green"
                          ><v-icon color="white" @click="editItemFunction()"
                            >edit</v-icon
                          ></v-btn
                        >
                        <v-btn round color="red"
                          ><v-icon
                            color="white"
                            @click="deleteGISItem(rightClickWindowData)"
                            >delete</v-icon
                          ></v-btn
                        >
                      </v-layout>
                    </v-card>
                  </gmap-info-window>

                  <gmap-info-window
                    v-if="polyInfoWindow"
                    :options="infoOptions"
                    :position="polyInfo.center"
                    :opened="polyInfoWindow"
                    @closeclick="polyInfoWindow = false"
                  >
                    <v-card flat color="white" v-if="polyInfo" width="250px">
                      <v-card-title class="grey--text"
                        >Network: {{ polyInfo.name }}</v-card-title
                      >
                      <v-card-text>
                        <v-layout justify-left align-center wrap>
                          <v-flex xs4 mx-1>
                            <h3 class="grey--text">Area</h3>
                          </v-flex>
                          <v-flex xs6 mx-1>
                            <h3 class="grey--text">
                              {{ polyInfo.area }} Km<span class="superscript"
                                >2</span
                              >
                            </h3>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-layout justify-center align-center wrap> </v-layout>
                    </v-card>
                  </gmap-info-window>

                  <gmap-info-window
                    v-if="showPlaceInfoWindow"
                    :position="placeInfoWindow.geometry.location"
                    :opened="placeInfoWindow.geometry"
                    @closeclick="showPlaceInfoWindow = false"
                  >
                    <v-card
                      flat
                      color="white"
                      v-if="showPlaceInfoWindow"
                      width="250px"
                    >
                      <v-card-text>
                        <v-layout justify-left align-center wrap>
                          <v-flex xs12>
                            <h3 class="grey--text">
                              {{ placeInfoWindow.formatted_address }}
                            </h3>
                          </v-flex>
                          <v-layout
                            justify-center
                            align-center
                            wrap
                            :key="placeInfoWindow.key"
                          >
                            <!-- <v-flex xs3 mx-1 > -->
                            <!-- <v-btn
                              :key="placeInfoWindow.key"
                              v-if="!placeInfoWindow.isLoading"
                              round
                              color="primary"
                              class="white--text"
                              @click="
                                testLocationLOS(
                                  placeInfoWindow.geometry.location
                                )
                              "
                            >
                              <v-icon color="white" padding="10%"
                                >settings_input_antenna</v-icon
                              >
                              Line of Sight</v-btn
                            >
                            <v-btn
                              :key="placeInfoWindow.key"
                              v-else
                              round
                              disabled
                              >Getting Results
                              <v-progress-circular
                                size="20"
                                indeterminate
                                color="white"
                              ></v-progress-circular
                            ></v-btn> -->
                            <!-- </v-flex> -->
                          </v-layout>

                          <div v-if="lineOfSightItem.length > 0">
                            <v-list-tile
                              v-for="line in lineOfSightItem"
                              :key="line.distance"
                              avatar
                              @click="selectedLineOfSightItem = line"
                            >
                              <v-list-tile-action>
                                <v-icon v-if="line.success" color="light-green"
                                  >check_circle</v-icon
                                >
                                <v-icon v-else color="red">cancel</v-icon>
                              </v-list-tile-action>

                              <v-list-tile-content>
                                <v-list-tile-title
                                  color="grey"
                                  v-text="line.tower.name"
                                ></v-list-tile-title>
                                <span class="grey--text font-weight-light"
                                  >{{ line.distance }} m</span
                                >
                              </v-list-tile-content>

                              <!-- <v-list-tile-content>
            </v-list-tile-content> -->
                            </v-list-tile>
                          </div>
                          <div
                            v-else-if="
                              placeInfoWindow.key && placeInfoWindow.key > 0
                            "
                          >
                            <v-list-tile>
                              <v-list-tile-conten>
                                <span class="grey--text font-weight-light"
                                  >No feasible towers</span
                                >
                              </v-list-tile-conten>
                            </v-list-tile>
                          </div>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </gmap-info-window>
                  <div v-if="showCoverageMap">
                    <gmap-circle
                      v-for="(pin, index) in markerArray.filter(
                        (x) => x.gisPointType.deviceMakeModel
                      )"
                      :key="index || showCoverageMap"
                      :center="{ lat: pin.lat, lng: pin.lng }"
                      :radius="pin.gisPointType.deviceMakeModel.distanceRange"
                      :visible="showCoverageMap"
                      :options="{
                        fillColor: '#19a3d1',
                        fillOpacity: 0.2,
                        strokeColor: '#19a3d1',
                        strokeOpacity: 0.8,
                        strokeWeight: 1,
                      }"
                    >
                    </gmap-circle>
                  </div>

                  <!-- v-else-if="!clusterGISPoints && currentZoom >= 16" -->

                  <!-- <div v-if="currentZoom >= 13"> -->

                  <!-- </div> -->
                  <gmap-custom-marker
                    v-for="marker in towerArray.filter((x) =>
                      bounds.contains({ lat: x.lat, lng: x.lng })
                    )"
                    :key="marker.id"
                    :marker="{ lat: marker.lat, lng: marker.lng }"
                    :clickable="true"
                    :draggable="isEditing"
                    alignment="center"
                    class="z-index: 5"
                    @click.native="!isPlotting ? showMarkerInfo(marker) : null"
                    @contextmenu.native="rightClickHandler($event, marker)"
                  >
                    <v-layout justify-center align-center wrap>
                      <v-flex xs12>
                        <v-avatar>
                          <!-- <v-img contain src="./tower.png"></v-img> -->

                          <v-icon
                            :class="[
                              {
                                selected: editItem && editItem.id == marker.id,
                              },
                              'outlined',
                            ]"
                            :color="marker.gisPointType.colour"
                            >podcasts</v-icon
                          >
                        </v-avatar>
                      </v-flex>
                      <v-flex xs12 v-if="showMarkerLabels">
                        <v-card flat color="white">
                          <span>{{ marker.name }}</span>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </gmap-custom-marker>
                </div>
                <div>
                  <gmap-polyline
                    v-for="(line, index) in lineArray"
                    :key="line.id && updateLineDatakey"
                    :path="line.array"
                    :options="{ strokeColor: line.gisPointType.colour }"
                    :editable="isEditing && editItem && editItem.id == line.id"
                    :clickable="true"
                    class="z-index: 4"
                    @click="
                      isPlotting && snapToLine && activePointType
                        ? snapToLineFunction($event, line)
                        : showLineInfo($event, line)
                    "
                    @path_changed="
                      isEditing ? updateLineData($event, line, index) : null
                    "
                  ></gmap-polyline>
                </div>
              </div>

              <!-- snapToLine Info Window -->
              <gmap-info-window
                v-if="snapToLineInfoWindow"
                :options="infoOptions"
                :position="snapToLineInfo.position"
                :opened="snapToLineInfoWindow"
                @closeclick="snapToLineInfoWindow = false"
                :key="key"
              >
                <v-card
                  flat
                  color="white"
                  :key="key"
                  v-if="
                    isPlotting &&
                    snapToLine &&
                    snapToLineInfo.id &&
                    activePointType &&
                    activePointType.id
                  "
                >
                  <v-card-title flat color="primary">
                    <h3 class="title grey--text">
                      {{ snapToLineInfo.name }}
                    </h3>
                  </v-card-title>
                  <v-card-text mx-1>
                    <v-layout
                      justify-center
                      align-center
                      wrap
                      class="text-xs-center"
                    >
                      <v-flex xs12>
                        <h3 class="title grey--text">
                          Select a tube in which the
                          {{ activePointType.name }} runs:
                        </h3>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout justify-center align-center wrap>
                          <v-stage
                            :config="configKonva"
                            v-for="i in snapToLineInfo.gisPointType.tubes"
                            :key="i"
                          >
                            <v-layer>
                              <v-circle
                                :config="{
                                  x: 40,
                                  y: 40,
                                  radius: 35,
                                  fill: 'white',
                                  stroke: fibreColours[i - 1],
                                  strokeWidth: 6,
                                }"
                                @click="selectTube(i)"
                              >
                              </v-circle>
                            </v-layer>
                          </v-stage>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions> </v-card-actions>
                </v-card>
              </gmap-info-window>

              <!-- Marker Cluster Info Window -->

              <gmap-info-window
                v-if="clusterInfoWindow"
                :options="infoOptions"
                :position="clusterInfoWindowData.center"
                :opened="clusterInfoWindow"
                @closeclick="clusterInfoWindow = false"
              >
                <v-card
                  flat
                  color="white"
                  v-if="clusterInfoWindowData"
                  :key="clusterKey"
                  width="250px"
                >
                  <v-card-title flat color="primary">
                    <h3 class="title grey--text">Cluster Items</h3>
                  </v-card-title>
                  <v-card-text mx-1>
                    <v-flex xs12>
                      <v-card
                        hover
                        color="white"
                        v-for="markerList in clusterInfoWindowData.markers"
                        :key="markerList[0].id"
                        class="my-1"
                        @click="
                          markerList.length > 1
                            ? showCluster(markerList)
                            : (zoom = 20),
                            (currentZoom = 20),
                            (center = {
                              lat: markerList[0].lat,
                              lng: markerList[0].lng,
                            });
                          clusterInfoWindow = false;
                        "
                      >
                        <v-flex
                          v-for="marker in markerList"
                          :key="marker.id"
                          xs12
                        >
                          <v-card flat color="white" tile>
                            <v-layout justify-left align-center wrap>
                              <v-flex xs3 mx-1>
                                <v-icon :color="marker.gisPointType.colour">{{
                                  marker.gisPointType.icon
                                }}</v-icon>
                              </v-flex>
                              <v-flex xs8 mx-1>
                                <h3 class="grey--text">{{ marker.name }}</h3>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-flex>
                      </v-card>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </gmap-info-window>

              <!-- Marker Info Window -->
              <gmap-info-window
                v-if="markerInfoWindow"
                :options="infoOptions"
                :position="{
                  lat: markerInfoWindowData.lat,
                  lng: markerInfoWindowData.lng,
                }"
                :opened="markerInfoWindow"
                @closeclick="markerInfoWindow = false"
                :key="key"
              >
                <v-card
                  flat
                  color="white"
                  :key="key"
                  v-if="
                    markerInfoWindowData &&
                    markerInfoWindowData.id &&
                    !isEditing
                  "
                >
                  <v-card-title flat color="primary">
                    <h3 v-if="!isEditing" class="title grey--text">
                      {{ markerInfoWindowData.name }}
                    </h3>
                    <v-text-field
                      v-else
                      class="title grey--text"
                      v-model="markerInfoWindowData.name"
                      label="Name"
                      @change="updateItem(markerInfoWindowData)"
                    ></v-text-field>
                  </v-card-title>
                  <v-card-text mx-1>
                    <v-layout
                      justify-left
                      align-center
                      wrap
                      class="text-xs-left"
                    >
                      <v-flex xs6>
                        <h3 class="grey--text">Type:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text font-weight-light">
                          {{ markerInfoWindowData.gisPointType.name }}
                        </h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text">Latitude:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text font-weight-light">
                          {{ markerInfoWindowData.lat }}
                        </h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text">Longitude:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text font-weight-light">
                          {{ markerInfoWindowData.lng }}
                        </h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text">Asset Tag:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3
                          v-if="!isEditing"
                          class="grey--text font-weight-light"
                        >
                          {{ markerInfoWindowData.assetTag }}
                        </h3>
                        <v-text-field
                          v-else
                          class="grey--text"
                          v-model="markerInfoWindowData.assetTag"
                          @change="updateItem(markerInfoWindowData)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text">Install Date:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3
                          v-if="!isEditing"
                          class="grey--text font-weight-light"
                        >
                          {{ markerInfoWindowData.installedDate }}
                        </h3>
                        <v-menu v-else :close-on-content-click="false">
                          <v-text-field
                            :value="markerInfoWindowData.installedDate"
                            slot="activator"
                            required
                            label="Install Date"
                            prepend-icon="date_range"
                          ></v-text-field>
                          <v-date-picker
                            v-model="markerInfoWindowData.installedDate"
                            @change="updateItem(markerInfoWindowData)"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text">Install Contractor:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3
                          v-if="!isEditing"
                          class="grey--text font-weight-light"
                        >
                          {{ markerInfoWindowData.installedBy }}
                        </h3>
                        <v-text-field
                          v-else
                          class="grey--text"
                          v-model="markerInfoWindowData.installedBy"
                          @change="updateItem(markerInfoWindowData)"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-layout justify-center>
                      <v-btn
                        color="red"
                        round
                        @click="deleteGISItem(markerInfoWindowData)"
                        ><v-icon color="white">delete</v-icon></v-btn
                      >
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </gmap-info-window>

              <!-- Line Info Window -->
              <gmap-info-window
                v-if="lineInfoWindow"
                :options="infoOptions"
                :position="lineInfoWindowData.position"
                :opened="lineInfoWindow"
                @closeclick="lineInfoWindow = false"
                :key="key"
              >
                <v-card
                  flat
                  color="white"
                  :key="key"
                  v-if="
                    !isEditing && lineInfoWindowData && lineInfoWindowData.id
                  "
                >
                  <v-card-title flat color="primary">
                    <h3 v-if="!isEditing" class="title grey--text">
                      {{ lineInfoWindowData.name }}
                    </h3>
                    <v-text-field
                      v-else
                      class="title grey--text"
                      v-model="lineInfoWindowData.name"
                      label="Name"
                      @change="updateItem(lineInfoWindowData)"
                    ></v-text-field>
                  </v-card-title>
                  <v-card-text mx-1>
                    <v-layout
                      justify-left
                      align-center
                      wrap
                      class="text-xs-left"
                    >
                      <v-flex xs6>
                        <h3 class="grey--text">Type:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text font-weight-light">
                          {{ lineInfoWindowData.gisPointType.name }}
                        </h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text">Length:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text font-weight-light">
                          {{ lineInfoWindowData.length }} m
                        </h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text">Asset Tag:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3
                          v-if="!isEditing"
                          class="grey--text font-weight-light"
                        >
                          {{ lineInfoWindowData.assetTag }}
                        </h3>
                        <v-text-field
                          v-else
                          class="grey--text"
                          v-model="lineInfoWindowData.assetTag"
                          @change="updateItem(lineInfoWindowData)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text">Install Date:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3
                          v-if="!isEditing"
                          class="grey--text font-weight-light"
                        >
                          {{ lineInfoWindowData.installedDate }}
                        </h3>
                        <v-menu v-else :close-on-content-click="false">
                          <v-text-field
                            :value="lineInfoWindowData.installedDate"
                            slot="activator"
                            required
                            label="Install Date"
                            prepend-icon="date_range"
                          ></v-text-field>
                          <v-date-picker
                            v-model="lineInfoWindowData.installedDate"
                            @change="updateItem(lineInfoWindowData)"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs6>
                        <h3 class="grey--text">Install Contractor:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3
                          v-if="!isEditing"
                          class="grey--text font-weight-light"
                        >
                          {{ lineInfoWindowData.installedBy }}
                        </h3>
                        <v-text-field
                          v-else
                          class="grey--text"
                          v-model="lineInfoWindowData.installedBy"
                          @change="updateItem(lineInfoWindowData)"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs6 v-if="lineInfoWindowData.tubes">
                        <h3 class="grey--text">Tubes:</h3>
                      </v-flex>
                      <v-flex xs6>
                        <h3
                          v-if="!isEditing && lineInfoWindowData.tubes"
                          class="grey--text font-weight-light"
                        >
                          {{ lineInfoWindowData.installedBy }}
                        </h3>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <!-- <v-layout
                    justify-center
                    align-center
                    wrap
                    class="text-xs-center"
                  >
                    <v-flex>
                      <v-responsive :aspect-ratio="1">
                        <v-card
                          id="circle-card"
                          max-width="800px"
                          max-height="800px"
                          min-height="200px"
                          min-width="200px"
                          hover
                          color="white"
                          class="text-xs-center"
                        >
                          <v-container fill-height>
                            <v-card-text class="text-xs-center">
                              <div>
                                <v-layout
                                  ma-1
                                  justify-center
                                  align-center
                                  wrap
                                  class="text-xs-center"
                                >
                                  <v-flex
                                    v-for="(
                                      tube, index
                                    ) in lineInfoWindowData.tubes"
                                    :key="tube.id"
                                  >
                                    <v-card-text class="text-xs-center">
                                      <v-layout
                                        justify-center
                                        align-center
                                        wrap
                                        class="text-xs-center"
                                        v-if="
                                          tube.length > 0 &&
                                          fibreColours[index] != 'white'
                                        "
                                      >
                                        <v-flex
                                          v-for="(subtube, index) in tube"
                                          :key="subtube.id"
                                          ml-2
                                        >
                                          <v-responsive
                                            :aspect-ratio="1"
                                            max-width="240px"
                                          >
                                            <v-tooltip top>
                                              <template
                                                #activator="{ on: tooltip }"
                                              >
                                                <v-card
                                                  hover
                                                  id="circle-card-sub"
                                                  :style="{
                                                    border:
                                                      '5px solid ' +
                                                      fibreColours[index] +
                                                      ' !important',
                                                  }"
                                                  color="white"
                                                  class="text-xs-center"
                                                  v-on="{ ...tooltip }"
                                                >
                                                  <v-card-text>
                                                    <v-container fill-height>
                                                      <v-layout
                                                        xs12
                                                        justify-center
                                                        align-center
                                                        wrap
                                                        class="text-xs-center"
                                                      >
                                                        <v-flex
                                                          v-for="innerTube of subtube
                                                            .gisPointType.tubes"
                                                          :key="innerTube"
                                                        >
                                                          <v-card
                                                            v-if="
                                                              subtube
                                                                .gisPointType
                                                                .tubes > 8
                                                            "
                                                            hover
                                                            class="circle-card-inner"
                                                            :color="
                                                              fibreColours[
                                                                innerTube - 1
                                                              ]
                                                            "
                                                          >
                                                            <v-card-text
                                                              class="text-xs-center"
                                                            >
                                                              <div
                                                                v-if="
                                                                  !subtube
                                                                    .gisPointType
                                                                    .isFibre
                                                                "
                                                              >
                                                                <h4
                                                                  class="white--text"
                                                                  v-if="
                                                                    fibreColours[
                                                                      innerTube -
                                                                        1
                                                                    ] !=
                                                                      'white' &&
                                                                    fibreColours[
                                                                      innerTube -
                                                                        1
                                                                    ] !=
                                                                      'yellow'
                                                                  "
                                                                >
                                                                  {{
                                                                    innerTube
                                                                  }}
                                                                </h4>
                                                                <h4 v-else>
                                                                  {{
                                                                    innerTube
                                                                  }}
                                                                </h4>
                                                              </div>
                                                              <div v-else>
                                                                <h4
                                                                  class="white--text"
                                                                  v-if="
                                                                    fibreColours[
                                                                      innerTube -
                                                                        1
                                                                    ] !=
                                                                      'white' &&
                                                                    fibreColours[
                                                                      innerTube -
                                                                        1
                                                                    ] !=
                                                                      'yellow'
                                                                  "
                                                                >
                                                                  {{
                                                                    subtube
                                                                      .gisPointType
                                                                      .numberOfCores /
                                                                    subtube
                                                                      .gisPointType
                                                                      .tubes
                                                                  }}
                                                                </h4>
                                                                <h4 v-else>
                                                                  {{
                                                                    subtube
                                                                      .gisPointType
                                                                      .numberOfCores /
                                                                    subtube
                                                                      .gisPointType
                                                                      .tubes
                                                                  }}
                                                                </h4></div>
                                                            </v-card-text>
                                                          </v-card>
                                                          <v-card
                                                            v-else
                                                            hover
                                                            class="circle-card-inner ma-1 ml-2"
                                                            :color="
                                                              fibreColours[
                                                                innerTube - 1
                                                              ]
                                                            "
                                                          >
                                                            <v-card-text
                                                              class="text-xs-center"
                                                            >
                                                              <div
                                                                v-if="
                                                                  !subtube
                                                                    .gisPointType
                                                                    .isFibre
                                                                "
                                                              >
                                                                <v-tooltip
                                                                  bottom
                                                                >
                                                                  <template
                                                                    #activator="{
                                                                      on: subtooltip,
                                                                    }"
                                                                  >
                                                                    <v-icon
                                                                      color="white"
                                                                      v-on="{
                                                                        ...subtooltip,
                                                                      }"
                                                                      v-if="
                                                                        subtube.downStreamGisPoints &&
                                                                        subtube.downStreamGisPoints.find(
                                                                          (x) =>
                                                                            x.tubeColourIndex ==
                                                                            innerTube -
                                                                              1
                                                                        )
                                                                      "
                                                                      >{{
                                                                        subtube.downStreamGisPoints.find(
                                                                          (x) =>
                                                                            x.tubeColourIndex ==
                                                                            innerTube -
                                                                              1
                                                                        )
                                                                          .gisPointType
                                                                          .icon
                                                                      }}</v-icon
                                                                    >
                                                                    <h4
                                                                      class="white--text"
                                                                      v-else-if="
                                                                        fibreColours[
                                                                          innerTube -
                                                                            1
                                                                        ] !=
                                                                          'white' &&
                                                                        fibreColours[
                                                                          innerTube -
                                                                            1
                                                                        ] !=
                                                                          'yellow'
                                                                      "
                                                                      v-on="{
                                                                        ...subtooltip,
                                                                      }"
                                                                    >
                                                                      {{
                                                                        innerTube
                                                                      }}
                                                                    </h4>
                                                                    <h4
                                                                      v-else
                                                                      v-on="{
                                                                        ...subtooltip,
                                                                      }"
                                                                    >
                                                                      {{
                                                                        innerTube
                                                                      }}
                                                                    </h4>
                                                                  </template>
                                                                  <span>{{
                                                                    subtube.downStreamGisPoints &&
                                                                    subtube.downStreamGisPoints.find(
                                                                      (x) =>
                                                                        x.tubeColourIndex ==
                                                                        innerTube -
                                                                          1
                                                                    )
                                                                      ? subtube.downStreamGisPoints.find(
                                                                          (x) =>
                                                                            x.tubeColourIndex ==
                                                                            innerTube -
                                                                              1
                                                                        )
                                                                          .gisPointType
                                                                          .name
                                                                      : "Tube " +
                                                                        innerTube
                                                                  }}</span>
                                                                </v-tooltip>
                                                              </div>
                                                              <div v-else>
                                                                <v-card
                                                                  class="circle-card-inner"
                                                                  v-for="strand in subtube
                                                                    .gisPointType
                                                                    .numberOfCores /
                                                                  subtube
                                                                    .gisPointType
                                                                    .tubes"
                                                                  :key="strand"
                                                                  :color="
                                                                    fibreColours[
                                                                      strand - 1
                                                                    ]
                                                                  "
                                                                ></v-card>
                                                              </div>
                                                            </v-card-text>
                                                          </v-card>
                                                        </v-flex>
                                                      </v-layout>
                                                    </v-container>
                                                  </v-card-text>
                                                </v-card>
                                              </template>
                                              <v-card color="grey --darken-5">
                                                <v-card-text
                                                  class="text-xs-left white--text"
                                                >
                                                  <v-layout
                                                    justify-left
                                                    align-left
                                                    wrap
                                                  >
                                                    <v-flex xs4 mx-1>
                                                      <h3>Name:</h3></v-flex
                                                    >
                                                    <v-flex xs4 mx-1>{{
                                                      subtube.name
                                                    }}</v-flex>
                                                    <v-flex xs4 mx-1
                                                      ><h3>ID:</h3></v-flex
                                                    >
                                                    <v-flex xs4 mx-1>{{
                                                      subtube.id
                                                    }}</v-flex>
                                                    <v-flex xs4 mx-1
                                                      ><h3>Type:</h3></v-flex
                                                    >
                                                    <v-flex xs4 mx-1>{{
                                                      subtube.gisPointType.name
                                                    }}</v-flex>
                                                  </v-layout>
                                                </v-card-text>
                                              </v-card>
                                            </v-tooltip>
                                          </v-responsive>
                                        </v-flex>
                                      </v-layout>
                                      <v-layout
                                        justify-center
                                        align-center
                                        wrap
                                        class="text-xs-center"
                                        v-else-if="
                                          tube.length == 0 &&
                                          lineInfoWindowData.tubes.length > 1
                                        "
                                      >
                                        <v-responsive :aspect-ratio="1">
                                          <v-card
                                            hover
                                            id="circle-card-sub"
                                            max-height="120px"
                                            max-width="100px"
                                            style="
                                              border: 3px solid rgb(80, 79, 79) !important;
                                            "
                                            :color="fibreColours[index]"
                                            class="text-xs-center ma-4"
                                          >
                                            <v-card-text>
                                              <h1
                                                class="white--text"
                                                v-if="
                                                  fibreColours[index] != 'white'
                                                "
                                              >
                                                {{ index + 1 }}
                                              </h1>
                                              <h1 v-else-if="tube.length == 0">
                                                {{ index + 1 }}
                                              </h1>
                                            </v-card-text>
                                          </v-card>
                                        </v-responsive>
                                      </v-layout>
                                    </v-card-text>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </v-card-text>
                          </v-container>
                        </v-card>
                      </v-responsive>
                    </v-flex>
                  </v-layout> -->

                  <v-card-actions>
                    <v-layout justify-center>
                      <v-btn
                        color="red"
                        round
                        @click="deleteGISItem(lineInfoWindowData)"
                        ><v-icon color="white">delete</v-icon></v-btn
                      >
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </gmap-info-window>

              <gmap-info-window
                v-if="multiplePointWindow && newGisData.length > 0"
                :options="infoOptions"
                :position="
                  newGisData[newGisData.length - 1].data[
                    newGisData[newGisData.length - 1].data.length - 1
                  ]
                "
                :opened="multiplePointWindow"
                @closeclick="multiplePointWindow = false"
                :key="key"
              >
                <v-card flat color="white" :key="key">
                  <v-card-title flat color="primary">
                    <h3 class="title grey--text">
                      Select the preferred point:
                    </h3>
                  </v-card-title>
                  <v-card-text>
                    <v-layout justify-center align-center wrap>
                      <v-card
                        ma-1
                        hover
                        v-for="point in nearbyPoints"
                        :key="point.id"
                        @click="addNewGisDataPoint(point)"
                      >
                        <v-layout justify-center align-center wrap>
                          <v-flex xs10 mx-1>
                            <h3 class="grey--text">
                              <v-icon>{{ point.gisPointType.icon }}</v-icon>
                              {{ point.name }}
                            </h3>
                          </v-flex>

                          <h4 class="grey--text">
                            Distance from selected point:
                            <span class="font-weight-light"
                              >{{ Math.round(point.dist * 100) / 100 }}m
                            </span>
                          </h4>
                        </v-layout>
                      </v-card>
                      <!-- <v-list-tile
                          v-for="point in nearbyPoints"
                          :key="point.id"
                          @click="addNewGisDataPoint(point)"
                        >
                          <v-list-tile-action
                            ><v-icon class="grey--text">{{
                              point.gisPointType.icon
                            }}</v-icon></v-list-tile-action
                          >
                          <v-list-tile-title class="grey--text">{{
                            point.name
                          }}</v-list-tile-title>
                          <v-list-tile-subtitle class="grey--text"
                            >{{
                              Math.round(point.dist * 100) / 100
                            }}m</v-list-tile-subtitle
                          >
                        </v-list-tile> -->
                    </v-layout>
                  </v-card-text>
                </v-card>
              </gmap-info-window>

              <!-- Main toolbar -->
              <div slot="visible">
                <v-card
                  class="ma-1"
                  style="
                    top: 0;
                    left: 35%;
                    height: auto;
                    position: absolute;
                    z-index: 100;
                  "
                  flat
                >
                  <v-toolbar flat color="white" dense>
                    <v-menu
                      bottom
                      offset-y
                      :nudge-width="200"
                      :close-on-content-click="false"
                      mx-1
                    >
                      <template #activator="{ on: menu }">
                        <v-tooltip bottom>
                          <template #activator="{ on: tooltip }"
                            ><v-icon round v-on="{ ...tooltip, ...menu }"
                              >public</v-icon
                            >
                          </template>
                          <span>Map Type</span>
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-tile>
                          <v-list-tile-action
                            ><v-checkbox
                              v-model="mapType"
                              value="roadmap"
                            ></v-checkbox
                          ></v-list-tile-action>
                          <v-list-tile-title
                            ><v-icon>directions_car</v-icon> Road
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-action
                            ><v-checkbox
                              v-model="mapType"
                              value="satellite"
                            ></v-checkbox
                          ></v-list-tile-action>
                          <v-list-tile-title
                            ><v-icon>radar</v-icon> Satellite
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-action
                            ><v-checkbox
                              v-model="mapType"
                              value="terrain"
                            ></v-checkbox
                          ></v-list-tile-action>
                          <v-list-tile-title
                            ><v-icon>terrain</v-icon> Terrain
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                    <v-menu
                      bottom
                      offset-y
                      :nudge-width="200"
                      :close-on-content-click="false"
                    >
                      <template #activator="{ on: menu }">
                        <v-tooltip bottom>
                          <template #activator="{ on: tooltip }"
                            ><v-icon round v-on="{ ...tooltip, ...menu }"
                              >layers</v-icon
                            >
                          </template>
                          <span>Layers</span>
                        </v-tooltip>
                      </template>

                      <v-list>
                        <v-list-tile>
                          <!-- <v-avatar> -->
                          <v-list-tile-action>
                            <v-icon>radar</v-icon>
                          </v-list-tile-action>

                          <!-- </v-avatar> -->
                          <v-list-tile-action>
                            <v-checkbox v-model="showCoverageMap"></v-checkbox>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>Coverage Map</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-group
                          v-for="(item, index) in layerItems"
                          :key="index"
                          v-model="item.active"
                          :prepend-icon="item.icon"
                          no-action
                        >
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-action
                                ><v-checkbox
                                  v-model="item.selected"
                                  @change="
                                    item.selected
                                      ? selectedLayers.push(item.id)
                                      : (selectedLayers = selectedLayers.filter(
                                          (x) => x != item.id
                                        ))
                                  "
                                ></v-checkbox
                              ></v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title>{{
                                  item.name
                                }}</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile
                            v-for="subItem in pointTypes.filter(
                              (x) => x.gisLayerId == item.id
                            )"
                            :key="subItem.id"
                          >
                            <v-list-tile-action>
                              <v-icon>{{ subItem.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>{{
                                subItem.name
                              }}</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action
                              ><v-checkbox
                                :disabled="
                                  !selectedLayers.includes(item.id)
                                    ? true
                                    : false
                                "
                                v-model="subItem.selected"
                                @change="
                                  subItem.selected
                                    ? selectedPoints.push(subItem.id)
                                    : (selectedPoints = selectedPoints.filter(
                                        (x) => x != subItem.id
                                      ))
                                "
                              ></v-checkbox
                            ></v-list-tile-action>
                          </v-list-tile>
                        </v-list-group>
                      </v-list>
                    </v-menu>

                    <v-tooltip bottom>
                      <template #activator="{ on: tooltip }"
                        ><v-icon
                          v-on="{ ...tooltip }"
                          @click="filterModal = true"
                          >filter_alt</v-icon
                        >
                      </template>
                      <span>Filter</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template #activator="{ on: tooltip }"
                        ><v-icon
                          v-on="{ ...tooltip }"
                          @click="getReportModal()"
                          :color="reportModal ? 'green' : 'dark-grey'"
                          >assessment</v-icon
                        >
                      </template>
                      <span>Report</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template #activator="{ on: tooltip }"
                        ><v-icon
                          v-on="{ ...tooltip }"
                          @click="
                            (lineOfSightTest = !lineOfSightTest),
                              (isEditing = false),
                              (isPlotting = false)
                          "
                          :color="lineOfSightTest ? 'green' : 'dark-grey'"
                          >connect_without_contact</v-icon
                        >
                      </template>
                      <span>Line of Sight</span>
                    </v-tooltip>

                    <!-- <v-tooltip bottom>
                      <template #activator="{ on: tooltip }"
                        ><v-icon
                          round
                          :color="
                            uploadImageOverlayModal ? 'green' : 'dark-grey'
                          "
                          v-on="{ ...tooltip }"
                          @click="uploadImageOverlayModal = true"
                          >wallpaper</v-icon
                        >
                      </template>
                      <span>Add Image Overlay</span>
                    </v-tooltip> -->

                    <v-menu
                      bottom
                      offset-y
                      :nudge-width="200"
                      :close-on-content-click="false"
                      mx-1
                    >
                      <template #activator="{ on: menu }">
                        <v-tooltip bottom>
                          <template #activator="{ on: tooltip }"
                            ><v-icon round v-on="{ ...tooltip, ...menu }"
                              >settings</v-icon
                            >
                          </template>
                          <span>Settings</span>
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-tile>
                          <v-list-tile-action
                            ><v-checkbox v-model="clusterGISPoints"></v-checkbox
                          ></v-list-tile-action>
                          <v-list-tile-title
                            >Cluster GIS points
                            <v-icon>group_work</v-icon></v-list-tile-title
                          >
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-action
                            ><v-checkbox
                              v-model="showMarkerLabels"
                              :disabled="clusterGISPoints ? true : false"
                            ></v-checkbox
                          ></v-list-tile-action>
                          <v-list-tile-title
                            >Show Marker Labels
                            <v-icon>label</v-icon></v-list-tile-title
                          >
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-action
                            ><v-checkbox
                              v-model="showOverlays"
                              @change="showOverlayRectangles = showOverlays"
                            ></v-checkbox
                          ></v-list-tile-action>
                          <v-list-tile-title
                            >Show Image Overlays
                            <v-icon>wallpaper</v-icon></v-list-tile-title
                          >
                        </v-list-tile>
                      </v-list>
                    </v-menu>

                    <v-tooltip bottom>
                      <template #activator="{ on: tooltip }"
                        ><v-icon
                          round
                          :color="isEditing ? 'green' : 'dark-grey'"
                          v-on="{ ...tooltip }"
                          @click="
                            isEditing
                              ? ((isEditing = false),
                                (isPlotting = false),
                                (showClusterHierarchy = false))
                              : ((isEditing = true),
                                (isPlotting = false),
                                (showClusterHierarchy = false))
                          "
                          >edit</v-icon
                        >
                      </template>
                      <span>Edit</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template #activator="{ on: tooltip }">
                        <v-icon
                          round
                          :color="isPlotting ? 'green' : 'dark-grey'"
                          v-on="{ ...tooltip }"
                          @click="
                            isPlotting
                              ? ((isPlotting = false),
                                (isEditing = false),
                                (showClusterHierarchy = false))
                              : ((isPlotting = true),
                                (isEditing = false),
                                (showClusterHierarchy = false))
                          "
                          >add_circle</v-icon
                        >
                      </template>
                      <span>Plot</span>
                    </v-tooltip>

                    <v-layout justify-center align-center wrap class="my-3">
                      <v-flex xs1 ml-3>
                        <v-icon
                          color="light-green"
                          v-if="groundLevel !== 25"
                          @click="groundLevel += 1"
                          >expand_less</v-icon
                        >
                        <v-icon v-else>expand_less</v-icon>
                        <v-icon
                          color="red"
                          v-if="groundLevel !== -1"
                          @click="groundLevel -= 1"
                          >expand_more</v-icon
                        >
                        <v-icon v-else>expand_more</v-icon>
                      </v-flex>
                      <v-flex xs6 ml-3>
                        <span class="grey--text" v-if="!loadingGisData">{{
                          availableGroundLevels.find((x) => x.id == groundLevel)
                            .name
                        }}</span>
                        <v-progress-circular
                          v-else
                          size="20"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-flex>
                    </v-layout>
                    <v-text-field
                      v-model="searchLocation"
                      id="pac-input"
                      style="width: 300px"
                      clearable
                    ></v-text-field>
                  </v-toolbar>
                </v-card>

                <!-- Editing Card -->
                <v-card
                  v-if="isEditing"
                  color="white"
                  max-width="400px"
                  style="
                    top: 60px;
                    right: 0;
                    height: auto;
                    position: absolute;
                    z-index: 100;
                  "
                >
                  <v-card-text mx-2 v-if="editItem && editItem.id">
                    <div>
                      <h3 class="grey--text">Editing Tools:</h3>
                      <v-layout justify-center align-center>
                        <v-btn flat @click="updateItem(editItem)"
                          ><v-icon color="blue">save</v-icon></v-btn
                        >
                        <v-btn flat @click="deleteGISItem(editItem)"
                          ><v-icon color="red">delete</v-icon></v-btn
                        >
                      </v-layout>
                      <v-autocomplete
                        dense
                        height="15px"
                        label="Node"
                        v-model="editItem.locationNodeId"
                        :items="locationNodes"
                        item-text="name"
                        item-value="id"
                        clearable
                      ></v-autocomplete>
                      <v-autocomplete
                        dense
                        height="20px"
                        label="Network"
                        v-model="editItem.locationNetworkId"
                        :items="locationNetworks"
                        item-text="name"
                        item-value="id"
                        clearable
                        @change="
                          editItem.locationNetworkId
                            ? (editItem.locationNodeId = locationNetworks.find(
                                (x) => x.id === editItem.locationNetworkId
                              ).locationNodeId)
                            : null
                        "
                      ></v-autocomplete>
                    </div>
                    <!-- <div class="mt-2" v-if="activePointType.type == 'Point'">
                      <v-text-field
                        height="15px"
                        solo
                        type="number"
                        min="0"
                        v-model="manualPoint.lat"
                        label="Lat."
                      ></v-text-field>
                      <v-text-field
                        height="15px"
                        solo
                        label="Long."
                        type="number"
                        min="0"
                        v-model="manualPoint.lng"
                      ></v-text-field>
                      <v-btn
                        v-if="manualPoint.lat && manualPoint.lng"
                        color="light-green"
                        round
                        dark
                        @click="manuallyAddPoint(manualPoint)"
                        >Add Point</v-btn
                      >
                      <v-btn round disabled v-else>Add Point</v-btn>
                    </div> -->
                    <v-layout align-center wrap>
                      <v-flex xs6>
                        <v-checkbox
                          v-model="snapToPointCheck"
                          label="Single Point Snap"
                          :disabled="snapToLine"
                          @change="
                            (connectPoints = false),
                              (snapToLine = false),
                              (connectFromPoint = {}),
                              (connectToPoint = {})
                          "
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs6 v-if="!isEditing">
                        <v-checkbox
                          v-model="snapToLine"
                          label="Map to Line"
                          :disabled="
                            activePointType && activePointType.type !== 'Line'
                              ? true
                              : false
                          "
                          @change="
                            (snapToPointCheck = false), (connectPoints = false)
                          "
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs6 v-if="!isEditing">
                        <v-checkbox
                          v-model="mapToRoad"
                          label="Map to Road"
                          :disabled="
                            (activePointType &&
                              activePointType.type !== 'Line') ||
                            snapToLine
                              ? true
                              : false
                          "
                          @change="snapToPointCheck = false"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>

                    <v-flex
                      v-if="
                        snapToPointCheck &&
                        ((activePointType && activePointType.type == 'Point') ||
                          (isEditing &&
                            editItem &&
                            editItem.gisPointType.type == 'Point'))
                      "
                      my-0
                    >
                      <v-checkbox
                        v-model="isInsideConnectionPoint"
                        label="This item is inside the snap point"
                      ></v-checkbox>
                    </v-flex>

                    <v-flex v-if="snapToPointCheck">
                      <v-autocomplete
                        outline
                        clearable
                        label="Select a snap point"
                        v-model="snapPointType"
                        :items="pointTypes.filter((x) => x.type == 'Point')"
                        prepend-inner-icon="location_on"
                        item-text="name"
                        item-value="id"
                        return-object
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-tile-action
                              ><v-icon>{{
                                data.item.icon
                              }}</v-icon></v-list-tile-action
                            >
                            <v-list-tile-content>
                              <v-list-tile-sub-title
                                v-html="data.item.name"
                              ></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex v-if="connectPoints">
                      <v-autocomplete
                        outline
                        clearable
                        label="Upstream point"
                        v-model="connectFromPoint"
                        :items="pointTypes.filter((x) => x.type == 'Point')"
                        prepend-inner-icon="location_on"
                        item-text="name"
                        item-value="id"
                        return-object
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-tile-action
                              ><v-icon>{{
                                data.item.icon
                              }}</v-icon></v-list-tile-action
                            >
                            <v-list-tile-content>
                              <v-list-tile-title
                                v-html="data.item.name"
                              ></v-list-tile-title>
                              <v-list-tile-subtitle
                                class="grey--text"
                                v-html="data.item.gisLayer.name"
                              ></v-list-tile-subtitle>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex v-if="connectPoints">
                      <v-autocomplete
                        outline
                        clearable
                        label="Downstream point"
                        v-model="connectToPoint"
                        :items="pointTypes.filter((x) => x.type == 'Point')"
                        prepend-inner-icon="where_to_vote"
                        item-text="name"
                        item-value="id"
                        return-object
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-tile-action
                              ><v-icon>{{
                                data.item.icon
                              }}</v-icon></v-list-tile-action
                            >
                            <v-list-tile-content>
                              <v-list-tile-title
                                v-html="data.item.name"
                              ></v-list-tile-title>
                              <v-list-tile-subtitle
                                class="grey--text"
                                v-html="data.item.gisLayer.name"
                              ></v-list-tile-subtitle>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                  </v-card-text>
                </v-card>

                <v-card
                  v-if="isPlotting"
                  color="white"
                  max-width="300px"
                  style="
                    top: 60px;
                    right: 0;
                    height: auto;
                    position: absolute;
                    z-index: 100;
                  "
                >
                  <v-card-text mx-2>
                    <div>
                      <h3 class="grey--text">Plotting Tools:</h3>
                      <v-autocomplete
                        height="15px"
                        dense
                        outline
                        clearable
                        label="Select a Layer"
                        v-model="plottingLayer"
                        :items="layerItems"
                        prepend-inner-icon="layers"
                        item-text="name"
                        item-value="id"
                        return-object
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-tile-action
                              ><v-icon>{{
                                data.item.icon
                              }}</v-icon></v-list-tile-action
                            >
                            <v-list-tile-content>
                              <v-list-tile-sub-title
                                v-html="data.item.name"
                              ></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete
                        dense
                        :items="availableGroundLevels"
                        item-text="name"
                        item-value="id"
                        outline
                        label="Select a Level/Floor"
                        v-model="selectedLevel"
                      ></v-autocomplete>
                      <v-autocomplete
                        dense
                        height="15px"
                        label="Node"
                        v-model="selectedNode"
                        :items="locationNodes"
                        item-text="name"
                        item-value="id"
                      ></v-autocomplete>
                      <v-autocomplete
                        dense
                        height="20px"
                        label="Network"
                        v-model="selectedNetwork"
                        return-object
                        :items="locationNetworks"
                        item-text="name"
                        item-value="id"
                      ></v-autocomplete>
                    </div>
                    <!-- <div class="mt-2" v-if="activePointType.type == 'Point'">
                      <v-text-field
                        height="15px"
                        solo
                        type="number"
                        min="0"
                        v-model="manualPoint.lat"
                        label="Lat."
                      ></v-text-field>
                      <v-text-field
                        height="15px"
                        solo
                        label="Long."
                        type="number"
                        min="0"
                        v-model="manualPoint.lng"
                      ></v-text-field>
                      <v-btn
                        v-if="manualPoint.lat && manualPoint.lng"
                        color="light-green"
                        round
                        dark
                        @click="manuallyAddPoint(manualPoint)"
                        >Add Point</v-btn
                      >
                      <v-btn round disabled v-else>Add Point</v-btn>
                    </div> -->
                    <v-layout align-center wrap>
                      <v-flex xs6>
                        <v-checkbox
                          v-model="snapToPointCheck"
                          label="Single Point Snap"
                          @change="
                            (connectPoints = false),
                              (snapToLine = false),
                              (connectFromPoint = {}),
                              (connectToPoint = {})
                          "
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs6>
                        <v-checkbox
                          v-model="connectPoints"
                          label="Multi Point Snap"
                          :disabled="
                            (activePointType &&
                              activePointType.type !== 'Line') ||
                            snapToLine
                              ? true
                              : false
                          "
                          @change="
                            (snapToPointCheck = false), (snapToLine = false)
                          "
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs6>
                        <v-checkbox
                          v-model="snapToLine"
                          label="Map to Line"
                          :disabled="
                            activePointType && activePointType.type !== 'Line'
                              ? true
                              : false
                          "
                          @change="
                            (snapToPointCheck = false),
                              (connectPoints = false),
                              (mapToRoad = false)
                          "
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs6>
                        <v-checkbox
                          v-model="mapToRoad"
                          label="Map to Road"
                          :disabled="
                            (activePointType &&
                              activePointType.type !== 'Line') ||
                            !connectPoints
                              ? true
                              : false
                          "
                          @change="snapToPointCheck = false"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>

                    <v-flex
                      v-if="
                        (snapToPointCheck &&
                          activePointType &&
                          activePointType.type == 'Point') ||
                        snapToLine
                      "
                      my-0
                    >
                      <v-checkbox
                        v-model="isInsideConnectionPoint"
                        label="This item is inside the snap point"
                      ></v-checkbox>
                    </v-flex>

                    <v-flex v-if="snapToLine">
                      <v-autocomplete
                        outline
                        clearable
                        label="Select a snap line"
                        v-model="snapPointType"
                        :items="pointTypes.filter((x) => x.type == 'Line')"
                        prepend-inner-icon="location_on"
                        item-text="name"
                        item-value="id"
                        return-object
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-tile-action
                              ><v-icon>{{
                                data.item.icon
                              }}</v-icon></v-list-tile-action
                            >
                            <v-list-tile-content>
                              <v-list-tile-sub-title
                                v-html="data.item.name"
                              ></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex v-if="snapToPointCheck">
                      <v-autocomplete
                        outline
                        clearable
                        label="Select a snap point"
                        v-model="snapPointType"
                        :items="pointTypes.filter((x) => x.type == 'Point')"
                        prepend-inner-icon="location_on"
                        item-text="name"
                        item-value="id"
                        return-object
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-tile-action
                              ><v-icon>{{
                                data.item.icon
                              }}</v-icon></v-list-tile-action
                            >
                            <v-list-tile-content>
                              <v-list-tile-sub-title
                                v-html="data.item.name"
                              ></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex v-if="connectPoints">
                      <v-autocomplete
                        outline
                        clearable
                        label="From point"
                        v-model="connectFromPoint"
                        :items="pointTypes.filter((x) => x.type == 'Point')"
                        prepend-inner-icon="location_on"
                        item-text="name"
                        item-value="id"
                        return-object
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-tile-action
                              ><v-icon>{{
                                data.item.icon
                              }}</v-icon></v-list-tile-action
                            >
                            <v-list-tile-content>
                              <v-list-tile-title
                                v-html="data.item.name"
                              ></v-list-tile-title>
                              <v-list-tile-subtitle
                                class="grey--text"
                                v-html="data.item.gisLayer.name"
                              ></v-list-tile-subtitle>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex v-if="connectPoints">
                      <v-autocomplete
                        outline
                        clearable
                        label="To point"
                        v-model="connectToPoint"
                        :items="pointTypes.filter((x) => x.type == 'Point')"
                        prepend-inner-icon="where_to_vote"
                        item-text="name"
                        item-value="id"
                        return-object
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-tile-action
                              ><v-icon>{{
                                data.item.icon
                              }}</v-icon></v-list-tile-action
                            >
                            <v-list-tile-content>
                              <v-list-tile-title
                                v-html="data.item.name"
                              ></v-list-tile-title>
                              <v-list-tile-subtitle
                                class="grey--text"
                                v-html="data.item.gisLayer.name"
                              ></v-list-tile-subtitle>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                  </v-card-text>
                </v-card>

                <!-- Line of Sight Results -->
                <v-card
                  v-if="lineOfSightTest && lineOfSightModal"
                  color="white"
                  width="250px"
                  style="
                    top: 90px;
                    left: 0;
                    height: auto;
                    position: absolute;
                    z-index: 100;
                  "
                >
                  <h2 pa-3 class="grey--text">Feasibility Tests:</h2>
                  <v-list>
                    <div v-if="lineOfSightItem.length > 0">
                      <v-list-tile
                        v-for="line in lineOfSightItem"
                        :key="line.distance"
                        avatar
                        @click="selectedLineOfSightItem = line"
                      >
                        <v-list-tile-action>
                          <v-icon v-if="line.success" color="light-green"
                            >check_circle</v-icon
                          >
                          <v-icon v-else color="red">cancel</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title
                            color="grey"
                            v-text="line.tower.name"
                          ></v-list-tile-title>
                          <span class="grey--text font-weight-light"
                            >{{ line.distance }} m</span
                          >
                        </v-list-tile-content>

                        <!-- <v-list-tile-content>
            </v-list-tile-content> -->
                      </v-list-tile>
                    </div>
                    <div v-else>
                      <v-list-tile>
                        <v-list-tile-conten>
                          <span class="grey--text font-weight-light"
                            >No feasible towers</span
                          >
                        </v-list-tile-conten>
                      </v-list-tile>
                    </div>
                  </v-list>
                </v-card>

                <!-- Elevation modal -->
                <v-card
                  color="white"
                  width="40%"
                  class="mb-2"
                  style="
                    bottom: 0;
                    left: 1%;
                    height: auto;
                    position: absolute;
                    z-index: 100;
                  "
                  :key="selectedLineOfSightItem"
                  v-if="selectedLineOfSightItem && selectedLineOfSightItem.data"
                >
                  <!-- <v-toolbar flat color="primary">
            <h3 class="title white--text">Line of Sight</h3>
            <v-spacer></v-spacer>
            <v-btn flat color="white" @click="lineOfSightModal = false"
              >X</v-btn
            >
          </v-toolbar> -->
                  <v-toolbar flat color="white">
                    <h3 class="grey--text">
                      {{ selectedLineOfSightItem.tower.name }}:
                      {{ selectedLineOfSightItem.distance }}m
                    </h3>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="grey"
                      flat
                      @click="selectedLineOfSightItem = {}"
                      >X</v-btn
                    >
                  </v-toolbar>
                  <v-card-text>
                    <v-layout justify-center>
                      <v-flex xs12>
                        <linechart
                          v-if="
                            lineOfSightModal &&
                            selectedLineOfSightItem &&
                            selectedLineOfSightItem.data
                          "
                          height="150px"
                          :chartdata="{
                            labels: selectedLineOfSightItem.data.map(
                              (x, index) => index
                            ),
                            datasets: [
                              {
                                label: 'LOS',
                                data: selectedLineOfSightItem.los,
                                backgroundColor: selectedLineOfSightItem.success
                                  ? '#99cc33'
                                  : '#fc0303',
                                borderColor: selectedLineOfSightItem.success
                                  ? '#99cc33'
                                  : '#fc0303',
                                borderWidth: 1,
                                fill: false,
                              },
                              {
                                label: 'Elevation',
                                data: selectedLineOfSightItem.data.map(
                                  (x) => x.elevation
                                ),
                                backgroundColor: '#7cd8eb',
                                borderColor: '#7cd8eb',
                                borderWidth: 1,
                              },
                            ],
                          }"
                          :options="{
                            elements: {
                              point: {
                                radius: 0,
                              },
                            },
                          }"
                        ></linechart>
                      </v-flex>
                    </v-layout>

                    <!-- <v-card-actions v-if="selectedLineOfSightItem && selectedLineOfSightItem.tower">
              <v-layout justify-center align-center wrap>
                <v-flex xs6 mx-1>
                  <h3 class="grey--text">
                    Result:
                    <v-chip
                      color="light-green"
                      class="white--text"
                      v-if="selectedLineOfSightItem.success"
                      >Successful LOS</v-chip
                    >
                    <v-chip color="red" class="white--text" v-else
                      >Unsuccessful LOS</v-chip
                    >
                  </h3>
                </v-flex>
                <v-flex xs6 mx-1>
                  <h3 class="grey--text">
                    Distance to Tower:
                    <span class="font-weight-light"
                      >{{ Math.ceil(lineOfSightItem.tower.distance) }}m</span
                    >
                  </h3>
                </v-flex>
              </v-layout>
            </v-card-actions> -->
                  </v-card-text>
                </v-card>

                <!-- Cluster hierarchy -->
                <v-card
                  v-if="showClusterHierarchy"
                  color="white"
                  max-width="300px"
                  style="
                    top: 60px;
                    left: 0;
                    height: auto;
                    position: absolute;
                    z-index: 100;
                  "
                >
                  <div>
                    <v-card-text mx-2>
                      <!-- <h3 class="grey--text">Cluster Hierarchy:</h3> -->
                      <v-treeview
                        item-disabled="locked"
                        open-on-click
                        transition
                        class="grey--text"
                        :activatable="false"
                        :key="clusterHierarchykey"
                        :items="clusterHierarchy"
                        :load-children="fetchAssociatedData"
                        :active.sync="active"
                        :open.sync="open"
                      >
                        <template v-slot:prepend="{ item }">
                          <v-icon :color="item.gisPointType.colour">
                            {{ item.gisPointType.icon }}</v-icon
                          >
                        </template>
                        <template v-slot:label="{ item }">
                          <h4
                            class="text-xs-left"
                            @click="
                              item.gisPointType.type == 'Point'
                                ? showMarkerInfo(item)
                                : showLineInfo(item, item)
                            "
                          >
                            {{ item.name }}
                          </h4>
                          <i
                            ><h5
                              class="text-xs-left font-weight-light"
                              @click="
                                item.gisPointType.type == 'Point'
                                  ? showMarkerInfo(item)
                                  : showLineInfo(item, item)
                              "
                            >
                              {{ item.gisPointType.name }}
                            </h5></i
                          >
                        </template>
                      </v-treeview>
                    </v-card-text>
                  </div>
                </v-card>

                <v-card
                  v-if="activePointType && activePointType.id && isPlotting"
                  color="white"
                  max-width="400px"
                  style="
                    top: 0px;
                    left: 0;
                    height: auto;
                    position: absolute;
                    z-index: 100;
                  "
                >
                  <div>
                    <v-card-text mx-2>
                      <h3 class="grey--text">Attributes:</h3>
                      <div v-if="activePointType.type == 'Line'">
                        <v-text-field
                          height="20px"
                          label="Name"
                          v-model="lineItemInfo.name"
                        ></v-text-field>
                        <v-text-field
                          height="20px"
                          label="Asset tag"
                          v-model="lineItemInfo.assetTag"
                        ></v-text-field>

                        <v-menu :close-on-content-click="false">
                          <v-text-field
                            :value="lineItemInfo.installedDate"
                            slot="activator"
                            required
                            label="Install Date"
                            prepend-icon="date_range"
                          ></v-text-field>
                          <v-date-picker
                            v-model="lineItemInfo.installedDate"
                          ></v-date-picker>
                        </v-menu>
                        <v-text-field
                          class="grey--text"
                          label="Install Contractor"
                          v-model="lineItemInfo.installedBy"
                        ></v-text-field>
                        <v-layout
                          justify-center
                          align-center
                          wrap
                          v-if="activePointType.isFibre"
                        >
                          <v-flex xs5 mx-1>
                            <v-text-field
                              height="20px"
                              type="number"
                              min="0"
                              step="1"
                              label="Helix Factor (%)"
                              v-model="lineItemInfo.helixFactor"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 mx-1>
                            <v-text-field
                              height="20px"
                              type="number"
                              min="0"
                              step="1"
                              label="Sag Factor (%)"
                              v-model="lineItemInfo.sagFactor"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          justify-center
                          align-center
                          wrap
                          class="text-xs-left"
                        >
                          <v-flex xs6 v-if="lineItemInfo.length">
                            <h3 class="grey--text">Length:</h3>
                          </v-flex>
                          <v-flex xs6 v-if="lineItemInfo.length">
                            <h3 class="grey--text font-weight-light">
                              {{ lineItemInfo.length }}m
                            </h3>
                          </v-flex>
                          <v-flex xs6 v-if="lineItemInfo.length">
                            <h3 class="grey--text">Adjusted Length:</h3>
                          </v-flex>
                          <v-flex xs6 v-if="lineItemInfo.length">
                            <v-text-field
                              :key="lineItemInfo.adjustedLength"
                              label="Adjusted Length (m)"
                              v-model="lineItemInfo.adjustedLength"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 v-if="lineItemInfo.length">
                            <h4 class="grey--text text-xs-center">
                              Cost Estimation:
                            </h4>
                          </v-flex>
                          <v-flex v-if="lineItemInfo.length">
                            <v-text-field
                              label="Material cost per m (excl. VAT)"
                              v-model="lineItemInfo.costPriceExVatPerMetre"
                              type="number"
                              min="0"
                              step="1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex>
                            <v-checkbox
                              label="Labour charged per m"
                              v-model="lineItemInfo.labourChargedPerM"
                              @change="
                                (priceKey += 1),
                                  !lineItemInfo.labourChargedPerM
                                    ? (lineItemInfo.labourPerMetre = 0)
                                    : (lineItemInfo.labour = 0)
                              "
                            ></v-checkbox>
                          </v-flex>
                          <v-flex
                            v-if="
                              lineItemInfo.length &&
                              lineItemInfo.labourChargedPerM
                            "
                            :key="priceKey"
                          >
                            <v-text-field
                              label="Labour cost per m (excl. VAT)"
                              v-model="lineItemInfo.labourPerMetre"
                              type="number"
                              min="0"
                              step="1"
                              @change="priceKey += 1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex
                            v-else-if="lineItemInfo.length"
                            :key="priceKey"
                          >
                            <v-text-field
                              label="Flat labour Cost (excl. VAT)"
                              v-model="lineItemInfo.labour"
                              type="number"
                              min="0"
                              step="1"
                              @change="priceKey += 1"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs6 v-if="lineItemInfo.length">
                            <h3 class="grey--text">Estimated Cost:</h3>
                          </v-flex>
                          <v-flex
                            xs6
                            v-if="lineItemInfo.length"
                            :key="priceKey"
                          >
                            <h3
                              class="grey--text font-weight-light"
                              :key="priceKey"
                              v-if="lineItemInfo.labourChargedPerM"
                            >
                              {{
                                (lineItemInfo.costPriceExVatPerMetre *
                                  lineItemInfo.adjustedLength +
                                  lineItemInfo.adjustedLength *
                                    lineItemInfo.labourPerMetre)
                                  | currency
                              }}
                            </h3>
                            <h3
                              v-else
                              class="grey--text font-weight-light"
                              :key="priceKey"
                            >
                              {{
                                (lineItemInfo.costPriceExVatPerMetre *
                                  lineItemInfo.adjustedLength +
                                  parseFloat(lineItemInfo.labour))
                                  | currency
                              }}
                            </h3>
                          </v-flex>
                        </v-layout>
                      </div>
                      <div v-else-if="activePointType.type == 'Point'">
                        <v-layout justify-center align-center wrap>
                          <v-flex xs10 mx-1>
                            <v-text-field
                              v-model="markerItemInfo.prefix"
                              label="Prefix"
                              @change="markerItemInfoKey += 1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs10 mx-1>
                            <v-text-field
                              v-model="markerItemInfo.count"
                              type="number"
                              min="0"
                              label="Number"
                              @change="markerItemInfoKey += 1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs10 mx-1>
                            <v-text-field
                              v-model="markerItemInfo.suffix"
                              label="Suffix"
                              @change="markerItemInfoKey += 1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 :key="markerItemInfoKey">
                            <span class="grey--text" :key="markerItemInfoKey"
                              >Next Point:
                              <i>{{
                                markerItemInfo.prefix +
                                markerItemInfo.count.toString() +
                                markerItemInfo.suffix
                              }}</i></span
                            >
                          </v-flex>
                        </v-layout>
                        <v-menu :close-on-content-click="false">
                          <v-text-field
                            :value="markerItemInfo.installedDate"
                            slot="activator"
                            required
                            label="Install Date"
                            prepend-icon="date_range"
                          ></v-text-field>
                          <v-date-picker
                            v-model="markerItemInfo.installedDate"
                          ></v-date-picker>
                        </v-menu>
                        <v-text-field
                          class="grey--text"
                          label="Install Contractor"
                          v-model="markerItemInfo.installedBy"
                        ></v-text-field>
                        <v-text-field
                          label="Material cost per item (excl. VAT)"
                          v-model="markerItemInfo.costPriceExVat"
                          @change="priceKey += 1"
                        ></v-text-field>
                        <v-text-field
                          label="Labour cost per item (excl. VAT)"
                          v-model="markerItemInfo.labour"
                          @change="priceKey += 1"
                        ></v-text-field>
                        <v-layout justify-center align-center wrap>
                          <v-flex xs6>
                            <h3 class="grey--text">Estimated Cost:</h3>
                          </v-flex>
                          <v-flex xs6 :key="priceKey">
                            <h3
                              class="grey--text font-weight-light"
                              :key="priceKey || newGisData.length"
                            >
                              {{
                                (markerItemInfo.costPriceExVat *
                                  newGisData.length +
                                  markerItemInfo.labour * newGisData.length)
                                  | currency
                              }}
                            </h3>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-card-text>
                  </div>
                </v-card>

                <v-card
                  v-if="editItem && editItem.id && isEditing"
                  color="white"
                  max-width="400px"
                  style="
                    top: 0px;
                    left: 0;
                    height: auto;
                    position: absolute;
                    z-index: 100;
                  "
                  :key="editKey"
                >
                  <div :key="editKey">
                    <v-toolbar flat color="white">
                      <h3 class="grey--text">Attributes:</h3>
                      <v-spacer></v-spacer>
                      <v-btn
                        flat
                        color="grey"
                        small
                        @click="
                          (editItem = {}), (editKey += 1), (isEditing = false)
                        "
                        >X</v-btn
                      >
                    </v-toolbar>
                    <v-card-text mx-2>
                      <div v-if="editItem.gisPointType.type == 'Line'">
                        <v-flex xs12>
                          <v-layout justify-left align-center wrap>
                            <v-flex xs6>
                              <span class="grey--text">Type:</span>
                            </v-flex>
                            <v-flex xs6>
                              <span class="grey--text">{{
                                editItem.gisPointType.name
                              }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-text-field
                          height="20px"
                          label="Name"
                          v-model="editItem.name"
                        ></v-text-field>
                        <v-text-field
                          height="20px"
                          label="Asset tag"
                          v-model="editItem.assetTag"
                        ></v-text-field>

                        <v-menu :close-on-content-click="false">
                          <v-text-field
                            :value="editItem.installedDate"
                            slot="activator"
                            required
                            label="Install Date"
                            prepend-icon="date_range"
                          ></v-text-field>
                          <v-date-picker
                            v-model="editItem.installedDate"
                          ></v-date-picker>
                        </v-menu>
                        <v-text-field
                          class="grey--text"
                          label="Install Contractor"
                          v-model="editItem.installedBy"
                        ></v-text-field>
                        <v-layout
                          justify-center
                          align-center
                          wrap
                          v-if="editItem.gisPointType.isFibre"
                        >
                          <v-flex xs5 mx-1>
                            <v-text-field
                              height="20px"
                              type="number"
                              min="0"
                              step="1"
                              label="Helix Factor (%)"
                              v-model="editItem.helixFactor"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 mx-1>
                            <v-text-field
                              height="20px"
                              type="number"
                              min="0"
                              step="1"
                              label="Sag Factor (%)"
                              v-model="editItem.sagFactor"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          justify-center
                          align-center
                          wrap
                          class="text-xs-left"
                        >
                          <v-flex xs6 v-if="editItem.length">
                            <h3 class="grey--text">Length:</h3>
                          </v-flex>
                          <v-flex xs6 v-if="editItem.length">
                            <h3 class="grey--text font-weight-light">
                              {{ editItem.length }}m
                            </h3>
                          </v-flex>
                          <v-flex xs6 v-if="editItem.calculatedLength">
                            <h3 class="grey--text">Adjusted Length:</h3>
                          </v-flex>
                          <v-flex xs6 v-if="editItem.calculatedLength">
                            <v-text-field
                              :key="editItem.calculatedLength"
                              label="Adjusted Length (m)"
                              v-model="editItem.calculatedLength"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 v-if="editItem.calculatedLength">
                            <h4 class="grey--text text-xs-center">
                              Cost Estimation:
                            </h4>
                          </v-flex>
                          <v-flex v-if="editItem.calculatedLength">
                            <v-text-field
                              label="Material cost per m (excl. VAT)"
                              v-model="editItem.costPriceExVatPerMetre"
                              type="number"
                              min="0"
                              step="1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex>
                            <v-checkbox
                              label="Labour charged per m"
                              v-model="editItem.labourChargedPerM"
                              @change="
                                (priceKey += 1),
                                  !editItem.labourChargedPerM
                                    ? (editItem.labourPerMetre = 0)
                                    : (editItem.labour = 0)
                              "
                            ></v-checkbox>
                          </v-flex>
                          <v-flex
                            v-if="editItem.length && editItem.labourChargedPerM"
                            :key="priceKey"
                          >
                            <v-text-field
                              label="Labour cost per m (excl. VAT)"
                              v-model="editItem.labourPerMetre"
                              type="number"
                              min="0"
                              step="1"
                              @change="priceKey += 1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex v-else-if="editItem.length" :key="priceKey">
                            <v-text-field
                              label="Flat labour Cost (excl. VAT)"
                              v-model="editItem.labour"
                              type="number"
                              min="0"
                              step="1"
                              @change="priceKey += 1"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs6 v-if="editItem.calculatedLength">
                            <h3 class="grey--text">Estimated Cost:</h3>
                          </v-flex>
                          <v-flex
                            xs6
                            v-if="editItem.calculatedLength"
                            :key="priceKey"
                          >
                            <h3
                              class="grey--text font-weight-light"
                              :key="priceKey"
                              v-if="editItem.labourChargedPerM"
                            >
                              {{
                                (editItem.costPriceExVatPerMetre *
                                  editItem.calculatedLength +
                                  editItem.calculatedLength *
                                    editItem.labourPerMetre)
                                  | currency
                              }}
                            </h3>
                            <h3
                              v-else
                              class="grey--text font-weight-light"
                              :key="priceKey"
                            >
                              {{
                                (editItem.costPriceExVatPerMetre *
                                  editItem.calculatedLength +
                                  parseFloat(editItem.labour))
                                  | currency
                              }}
                            </h3>
                          </v-flex>
                        </v-layout>
                      </div>
                      <div v-else-if="editItem.gisPointType.type == 'Point'">
                        <v-layout justify-center align-center wrap>
                          <v-flex class="text-xs-left" xs12>
                            <v-layout justify-left align-center wrap>
                              <v-flex xs6>
                                <span class="grey--text">Type:</span>
                              </v-flex>
                              <v-flex xs6>
                                <v-chip class="grey--text">{{
                                  editItem.gisPointType.name
                                }}</v-chip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex>
                            <v-text-field
                              v-model="editItem.name"
                              label="Name"
                            ></v-text-field>
                          </v-flex>

                          <v-flex>
                            <v-text-field
                              v-model="editItem.assetTag"
                              label="Asset Tag"
                            ></v-text-field>
                          </v-flex>
                          <v-text-field
                            height="20px"
                            label="Elevation"
                            v-model="editItem.elevation"
                          ></v-text-field>
                        </v-layout>
                        <v-menu :close-on-content-click="false">
                          <v-text-field
                            :value="editItem.installedDate"
                            slot="activator"
                            required
                            label="Install Date"
                            prepend-icon="date_range"
                          ></v-text-field>
                          <v-date-picker
                            v-model="editItem.installedDate"
                          ></v-date-picker>
                        </v-menu>
                        <v-text-field
                          class="grey--text"
                          label="Install Contractor"
                          v-model="editItem.installedBy"
                        ></v-text-field>
                        <v-text-field
                          label="Material cost per item (excl. VAT)"
                          v-model="editItem.costPriceExVat"
                          @change="priceKey += 1"
                        ></v-text-field>
                        <v-text-field
                          label="Labour cost per item (excl. VAT)"
                          v-model="editItem.labour"
                          @change="priceKey += 1"
                        ></v-text-field>
                        <v-layout justify-center align-center wrap>
                          <v-flex xs6>
                            <h3 class="grey--text">Estimated Cost:</h3>
                          </v-flex>
                          <v-flex xs6 :key="priceKey">
                            <h3
                              class="grey--text font-weight-light"
                              :key="priceKey || newGisData.length"
                            >
                              {{
                                (editItem.costPriceExVat * editItem.length +
                                  editItem.labour * editItem.length)
                                  | currency
                              }}
                            </h3>
                          </v-flex>
                        </v-layout>
                      </div>
                      <v-card-actions>
                        <v-layout justify-center>
                          <v-btn
                            color="light-green"
                            @click="updateItem(editItem)"
                            round
                            dark
                          >
                            Save</v-btn
                          >
                        </v-layout>
                      </v-card-actions>
                    </v-card-text>
                  </div>
                </v-card>

                <v-card
                  class="ma-2"
                  style="
                    top: 0;
                    right: 0;
                    height: auto;
                    position: absolute;
                    z-index: 100;
                  "
                  flat
                >
                  <v-icon
                    v-if="!fullscreen"
                    large
                    @click="toggleFullscreenmode()"
                    >fullscreen</v-icon
                  >
                  <v-icon v-else large @click="toggleFullscreenmode()"
                    >fullscreen_exit</v-icon
                  >
                </v-card>

                <v-card
                  v-if="(isEditing || isPlotting) && plottingLayer"
                  color="white"
                  width="98%"
                  class="mb-2"
                  style="
                    bottom: 0;
                    left: 1%;
                    height: auto;
                    position: absolute;
                    z-index: 100;
                  "
                >
                  <v-layout
                    justify-center
                    align-center
                    wrap
                    ma-1
                    v-if="isPlotting"
                  >
                    <v-flex xs2 mx-1>
                      <v-text-field
                        label="Search"
                        v-model="pointTypeSearch"
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-spacer></v-spacer> -->
                    <v-flex xs1>
                      <v-btn
                        flat
                        round
                        v-if="
                          activePointTypes.length > 5 &&
                          activePointTypePageStart != 0
                        "
                        @click="pageDown()"
                        ><v-icon mr-1>chevron_left</v-icon></v-btn
                      >
                      <v-btn
                        flat
                        round
                        disabled
                        v-else-if="activePointTypes.length > 5"
                        ><v-icon mr-1>chevron_left</v-icon></v-btn
                      >
                    </v-flex>

                    <v-flex
                      xs1
                      v-for="(item, i) in viewActivePointTypes"
                      :key="i"
                    >
                      <v-card
                        hover
                        tile
                        color="white"
                        @click="activePointType = item"
                        :class="{
                          cardBorder:
                            activePointType.id && item.id == activePointType.id,
                          normalBorder:
                            !activePointType.id ||
                            item.id != activePointType.id,
                        }"
                      >
                        <v-layout justify-center align-center wrap py-1>
                          <v-flex xs12
                            ><v-icon>{{ item.icon }}</v-icon></v-flex
                          >
                          <v-flex xs12
                            ><h4 class="grey--text font-weight-light">
                              {{ item.name }}
                            </h4></v-flex
                          >
                        </v-layout>
                      </v-card>
                    </v-flex>
                    <v-flex xs1>
                      <v-btn
                        flat
                        round
                        v-if="
                          activePointTypes.length > 5 &&
                          activePointTypePageEnd < activePointTypes.length
                        "
                        @click="pageUp()"
                        ><v-icon mr-1>chevron_right</v-icon></v-btn
                      >
                      <v-btn
                        flat
                        round
                        disabled
                        v-else-if="activePointTypes.length > 5"
                        ><v-icon mr-1>chevron_right</v-icon></v-btn
                      >
                    </v-flex>

                    <!-- <v-spacer></v-spacer> -->
                    <!-- <v-layout justify-center wrap> -->
                    <v-flex xs1 ml-1>
                      <v-btn
                        round
                        dark
                        color="orange"
                        @click="undoLastPoint()"
                        v-if="newGisData.length > 0"
                        ><v-icon>undo</v-icon></v-btn
                      >
                      <v-btn v-else disabled round><v-icon>undo</v-icon></v-btn>
                      <v-btn
                        round
                        dark
                        color="light-blue"
                        @click="newLine()"
                        v-if="
                          newGisData.length > 0 &&
                          activePointType &&
                          activePointType.type == 'Line'
                        "
                        >New Line</v-btn
                      >
                      <!-- <v-btn v-else disabled round>New Line</v-btn> -->
                    </v-flex>
                    <v-flex xs1>
                      <v-btn
                        round
                        dark
                        color="light-green"
                        @click="savePoints()"
                        >Save</v-btn
                      >
                      <v-btn round dark color="red" @click="cancelPlotting()"
                        >Cancel</v-btn
                      >
                    </v-flex>
                    <!-- </v-layout> -->
                  </v-layout>
                </v-card>
              </div>
              <!-- </div> -->
            </gmap-map>
          </v-flex>

          <!-- <v-flex xs1 v-if="(isEditing || isPlotting)">
          
        </v-flex> -->
        </v-layout>
      </div>
      <v-dialog v-model="filterModal" persistent width="500px">
        <v-card flat color="white">
          <v-toolbar flat color="primary">
            <h3 class="title white--text">Filter</h3>
            <v-spacer></v-spacer>
            <v-btn flat color="white" @click="filterModal = false">X</v-btn>
          </v-toolbar>
          <v-card-text mx-1>
            <v-layout justify-center align-center wrap>
              <v-checkbox
                label="All Networks"
                v-model="selectAllNetworks"
              ></v-checkbox>
              <v-autocomplete
                clearable
                small-chips
                deletable-chips
                v-if="!selectAllNetworks"
                label="Networks"
                v-model="filterNetworks"
                chips
                :items="locationNetworks"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
              <v-checkbox
                label="All Nodes"
                v-model="selectAllNodes"
              ></v-checkbox>
              <v-autocomplete
                clearable
                v-if="!selectAllNodes"
                label="Nodes"
                v-model="filterNodes"
                small-chips
                deletable-chips
                :items="locationNodes"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center align-center wrap>
              <v-btn color="light-green" dark round @click="applyFilter()"
                >Apply Filter</v-btn
              >
              <v-btn color="red" dark round @click="clearFilter()"
                >Reset Filter</v-btn
              >
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Report Modal -->
      <v-dialog v-model="reportModal" persistent width="750px">
        <v-card flat color="white">
          <v-toolbar flat color="primary">
            <h3 class="title white--text">Report</h3>
            <v-spacer></v-spacer>
            <v-btn
              flat
              color="white"
              @click="(reportModal = false), (reportData = {})"
              >X</v-btn
            >
          </v-toolbar>
          <v-card-text ma-1>
            <v-layout justify-center align-center wrap>
              <v-flex xs4 mx-1>
                <v-checkbox
                  v-model="reportData.networkReport"
                  label="Network Report"
                  @change="
                    (reportData.nodeReport = false),
                      (reportData.locationNodeId = null)
                  "
                ></v-checkbox>
              </v-flex>
              <v-flex xs4 mx-1>
                <v-checkbox
                  v-model="reportData.nodeReport"
                  label="Node Report"
                  @change="
                    (reportData.networkReport = false),
                      (reportData.locationNetworkId = null)
                  "
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex xs4 mx-1>
                <v-select label="Report Type" :items="['BOM', 'BOQ']"></v-select>
              </v-flex> -->
              <v-flex xs4 mx-1 v-if="reportData.networkReport">
                <v-autocomplete
                  label="Select a Network"
                  clearable
                  v-model="reportData.locationNetworkId"
                  :items="locationNetworks"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs4 mx-1 v-if="reportData.nodeReport">
                <v-autocomplete
                  label="Select a Node"
                  clearable
                  v-model="reportData.locationNodeId"
                  :items="locationNodes"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <div
              v-if="reportData.data && reportData.data.length > 0"
              :key="reportData.loadingReportKey"
            >
              <v-data-table :items="reportData.data">
                <template
                  v-slot:items="props"
                  :items="reportData.data"
                  :headers="reportHeaders"
                >
                  <td class="text-xs-center">
                    {{ props.item.name }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.count }}
                  </td>
                  <td class="text-xs-center" v-if="props.item.length">
                    {{ props.item.length }} m
                  </td>
                  <td v-else></td>
                  <td class="text-xs-center">
                    {{ props.item.pricePerUnit }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.total }}
                  </td>
                </template>
              </v-data-table>
              <!-- <v-layout justify-center align-center wrap >
                 <v-flex xs8 mx-1 v-for="item in reportData.data" :key="item.gisPointTypeId">
                   <v-layout justify-left align-center wrap>
                     <v-flex xs4 mx-1>
              <h3 class="grey--text">{{item.name}}</h3>

                     </v-flex>
                     <v-flex xs4 mx-1>
              <h3 class="grey--text font-weight-light">{{item.count}}</h3>

                     </v-flex>
                   </v-layout> -->
              <!-- </v-flex>
              </v-layout> -->
            </div>
          </v-card-text>
          <v-card-actions>
            <v-layout
              justify-center
              align-center
              wrap
              :key="reportData.loadingReportKey"
            >
              <v-btn
                v-if="reportData.networkReport && reportData.locationNetworkId"
                round
                class="white--text"
                color="primary"
                @click="generateNetworkReport(reportData.locationNetworkId)"
                >Generate Report</v-btn
              >
              <v-btn
                v-else-if="
                  reportData.networkReport && !reportData.locationNetworkId
                "
                round
                disabled
                >Generate Report</v-btn
              >
              <span v-else-if="reportData.loadingReport" class="grey--text"
                >Generating Report
                <v-progress-circular
                  size="20"
                  indeterminate
                  color="primary"
                ></v-progress-circular
              ></span>

              <v-btn
                v-if="reportData.nodeReport && reportData.locationNodeId"
                round
                class="white--text"
                color="primary"
                @click="generateNodeReport(reportData.locationNodeId)"
                >Generate Report</v-btn
              >
              <v-btn v-else-if="reportData.nodeReport" round disabled
                >Generate Report</v-btn
              >
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="uploadImageOverlayModal" persistent width="1000px">
        <v-card flat color="white">
          <v-toolbar flat color="primary">
            <h3 class="white--text title">Add Image Overlay</h3>
            <v-spacer></v-spacer>
            <v-btn flat color="white" @click="uploadImageOverlayModal = false"
              >X</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <div>
              <!-- Note that 'ref' is important here (value can be anything). read the description about `ref` below. -->
              <input v-if="!cropped" type="file" @change="croppie" />
              <vue-croppie
                v-if="!cropped"
                ref="croppieRef"
                :enableOrientation="true"
                :boundary="{ width: 450, height: 300 }"
                :viewport="{ width: 400, height: 250, type: 'square' }"
              >
              </vue-croppie>

              <!-- the result -->
              <img v-bind:src="cropped" />
              <!-- Rotate angle is Number -->
              <v-btn
                v-if="!cropped"
                round
                color="primary"
                dark
                @click="rotate(-90)"
                >Rotate Left</v-btn
              >
              <v-btn
                v-if="!cropped"
                round
                color="primary"
                dark
                @click="rotate(90)"
                >Rotate Right</v-btn
              >
              <v-btn v-if="!cropped" round color="primary" dark @click="crop()"
                >Crop</v-btn
              >
              <v-layout justify-center align-center wrap>
                <!-- <v-btn v-if="cropped" round color="primary" dark @click="overlayImage=cropped, uploadImageOverlayModal=false, plottingImageOverlay=true">Okay</v-btn> -->
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-dialog v-model="lineOfSightModal" persistent width="1000px">
        <v-card color="white" v-if="lineOfSightItem">
          <v-toolbar flat color="primary">
            <h3 class="title white--text">Line of Sight</h3>
            <v-spacer></v-spacer>
            <v-btn flat color="white" @click="lineOfSightModal = false"
              >X</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <v-layout justify-center>
              <v-flex xs8 mx-1>
                <linechart
                  v-if="lineOfSightModal"
                  height="150px"
                  :chartdata="elevationData[0]"
                  :options="elevationData[1]"
                ></linechart>
              </v-flex>
            </v-layout>

            <v-card-actions v-if="lineOfSightItem && lineOfSightItem.tower">
              <v-layout justify-center align-center wrap>
                <v-flex xs6 mx-1>
                  <h3 class="grey--text">
                    Result:
                    <v-chip
                      color="light-green"
                      class="white--text"
                      v-if="lineOfSightItem.result"
                      >Successful LOS</v-chip
                    >
                    <v-chip color="red" class="white--text" v-else
                      >Unsuccessful LOS</v-chip
                    >
                  </h3>
                </v-flex>
                <v-flex xs6 mx-1>
                  <h3 class="grey--text">
                    Distance to Tower:
                    <span class="font-weight-light"
                      >{{ Math.ceil(lineOfSightItem.tower.distance) }}m</span
                    >
                  </h3>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog> -->
    </fullscreen>
  </div>
</template>

<script>
import Api from "../services/Api";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import image from "../../public/dpIcon.png";
import LineChart from "./LineChart.vue";
import BarChart from "./BarChart.vue";
import towerImage from "../../public/tower.png";

export default {
  components: {
    "gmap-custom-marker": GmapCustomMarker,
    linechart: LineChart,
    barchart: BarChart,
  },
  data() {
    return {
      cropped: null,
      images: [
        "http://i.imgur.com/fHNtPXX.jpg",
        "http://i.imgur.com/ecMUngU.jpg",
        "http://i.imgur.com/7oO6zrh.jpg",
        "http://i.imgur.com/miVkBH2.jpg",
      ],
      active: [],
      configKonva: {
        width: 80,
        height: 80,
      },

      open: [],
      activeTabName: "map",
      bounds: null,
      imageBounds: {
        north: -33.78843082451338,
        east: 18.530655807984207,
        south: -33.80376232648199,
        west: 18.496879284205992,
      },
      boundsChange: 0,
      center: { lng: -33.919473, lat: 18.427059 },
      clusterGISPoints: true,
      showMarkerLabels: false,
      showOverlays: false,
      overlayImage: null,
      geoData: {},
      gisData: [],
      drawDoubleLine: false,
      editKey: 0,
      towerImage: towerImage,
      fibreColours: [
        "blue",
        "orange",
        "green",
        "brown",
        "#708090",
        "white",
        "red",
        "black",
        "yellow",
        "#EE82EE",
        "#ff007f",
        "#40e0d0",
      ],
      groundLevel: 0,
      availableGroundLevels: [
        { id: -1, name: "Underground" },
        { id: 0, name: "Ground" },
        { id: 1, name: "1" },
        { id: 2, name: "2" },
        { id: 3, name: "3" },
        { id: 4, name: "4" },
        { id: 5, name: "5" },
        { id: 6, name: "6" },
        { id: 7, name: "7" },
        { id: 8, name: "8" },
        { id: 9, name: "9" },
        { id: 10, name: "10" },
        { id: 11, name: "11" },
        { id: 12, name: "12" },
        { id: 13, name: "13" },
        { id: 14, name: "14" },
        { id: 15, name: "15" },
        { id: 16, name: "16" },
        { id: 17, name: "17" },
        { id: 18, name: "18" },
        { id: 19, name: "19" },
        { id: 20, name: "20" },
        { id: 21, name: "21" },
        { id: 22, name: "22" },
        { id: 23, name: "23" },
        { id: 24, name: "24" },
        { id: 25, name: "25" },
      ],
      mapType: "terrain",
      loadingGisData: true,
      newGisData: [],
      networkPolygons: {},
      markers: [],
      places: [],
      polyInfo: {},
      polyInfoWindow: false,
      map: undefined,
      markerData: [],
      currentPlace: null,
      item: {},
      lineItemInfo: {},
      placeInfoWindow: {},
      showPlaceInfoWindow: false,
      markerItemInfo: {},
      markerItemInfoKey: 0,
      updateLineDatakey: 0,
      isInsideConnectionPoint: false,
      filterModal: false,
      fullscreen: false,
      key: 0,
      myCityData: null,
      priceKey: 0,
      itemModal: false,
      isEditing: false,
      isPlotting: false,
      infoContent: "",
      lineInfoWindow: false,
      lineInfoWindowData: {},
      markerInfoWindow: false,
      markerInfoWindowData: {},
      clusterInfoWindow: false,
      clusterInfoWindowData: {},
      rightClickWindow: false,
      rightClickWindowData: {},
      snapToLineInfo: {},
      snapToLineInfoWindow: false,
      clusterKey: 0,
      multiplePointWindow: false,
      activePlotType: "",
      activePointType: {},
      activePointTypePageStart: 0,
      activePointTypePageEnd: 5,
      manualPoint: {},
      polyData: [],
      lineData: [],
      locationNetworks: [],
      locationNodes: [],
      layerItems: [],
      plottingLayer: null,
      selectedLayers: [],
      selectedPoints: [],
      showCoverageMap: true,
      locationDataPoints: [],
      markerArray: [],
      towerArray: [],
      lineArray: [],
      zoomKey: 0,
      currentZoom: 12,
      snapPointDialog: false,
      enableSnap: true,
      connectPoints: false,
      snapToLine: false,
      mapToRoad: false,
      snapToPointCheck: false,
      showClusterHierarchy: false,
      clusterHierarchy: [],
      clusterHierarchykey: 0,
      connectFromPoint: {},
      connectToPoint: {},
      snapPointType: null,
      nearbyPoints: [],
      selectedLevel: 0,
      selectedNetwork: null,
      selectedNode: null,
      filterNetworks: [],
      filterNodes: [],
      selectAllNetworks: true,
      selectAllNodes: true,
      snackbar: false,
      text: "",
      filterKey: 0,
      pointTypeSearch: "",
      updatedLength: 0,
      uploadImageOverlayModal: false,
      allOverlayImages: [],
      overlayImages: [],
      newImageOverlay: {},
      imageOverlayKey: 0,
      plottingImageOverlay: false,
      reportModal: false,
      reportData: {},
      lineOfSightTest: false,
      lineOfSightItem: {},
      selectedLineOfSightItem: {},
      lineOfSightItemColors: [],
      lineOfSightModal: false,
      elevationData: [],
      searchLocation: "",
      plotItems: [
        { value: "line", title: "Line", icon: "timeline" },
        { value: "polygon", title: "Polygon", icon: "crop_square" },
        { value: "point", title: "Point", icon: "gps_fixed" },
      ],
      activePointTypes: [],
      viewActivePointTypes: [],
      pointTypes: [],
      reportHeaders: [
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Count",
          align: "center",
          value: "count",
        },
        {
          text: "Length",
          align: "center",
          value: "length",
        },
        {
          text: "Price per Unit",
          align: "center",
          value: "pricePerUnit",
        },
        {
          text: "Total",
          align: "center",
          value: "total",
        },
      ],
      tabs: [
        { name: "map", displayName: "Planner" },
        { name: "mapSettings", displayName: "Settings" },
      ],
      pointTypeHeaders: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Icon",
          align: "center",
          sortable: false,
        },
      ],
      myStyles: [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "geometry",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#bdbdbd",
            },
          ],
        },
        {
          featureType: "poi",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#c1d6e0",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#9cb0ba",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
      ],
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      searchLocation: "",
      zoom: 13,
    };
  },
  watch: {
    showCoverageMap(value) {
      if (!value) {
        this.map.data.setStyle({ visible: false });
        //         this.map.data.setMap(null)
        //         this.map.data.forEach((feature) => {
        //     this.map.data.remove(feature);
        // });
      } else {
        console.log(value);
        // this.plotMap()
        console.log(this.networkPolygons);
        // this.map.data.addGeoJson(this.networkPolygons)
        //  new google.maps.Data({ map: this.map });

        this.map.data.setStyle(function (feature) {
          return {
            // fillColor: feature.i.fno.primaryColour,
            fillOpacity: 0.3,
            strokeWeight: 2,
            // strokeColor: feature.i.fno.primaryColour,

            styles: {
              featureType: "poi",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
            visible: true,
          };
        });
        // this.map.data.setStyle({visible: true});

        // this.map.data.addGeoJson(this.networkPolygons)
        // this.plotMap()
      }
    },
    zoom(value) {
      this.currentZoom = value;
    },
    clusterGISPoints(value) {
      if (value == true) {
        this.showMarkerLabels = false;
      }
    },
    "lineItemInfo.helixFactor": {
      immediate: true,
      handler(value) {
        if (
          value &&
          this.lineItemInfo &&
          this.lineItemInfo.length &&
          this.activePointType.isFibre
        ) {
          let adjustments = Math.round(
            this.lineItemInfo.length *
              ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
                100)
          );
          this.lineItemInfo.adjustedLength =
            this.lineItemInfo.length + adjustments;
          this.priceKey += 1;
        }
      },
    },
    "lineItemInfo.sagFactor": {
      immediate: true,
      handler(value) {
        if (
          value &&
          this.lineItemInfo &&
          this.lineItemInfo.length &&
          this.activePointType.isFibre
        ) {
          let adjustments = Math.round(
            this.lineItemInfo.length *
              ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
                100)
          );
          this.lineItemInfo.adjustedLength =
            this.lineItemInfo.length + adjustments;
          this.priceKey += 1;
        }
      },
    },
    activePointType(value) {
      if (value && value.type == "Line") {
        this.lineItemInfo = {
          name: value.name,
          helixFactor: 0,
          sagFactor: 0,
          length: 0,
          adjustedLength: 0,
          labour: 0,
          labourPerMetre: 0,
          labourChargedPerM: true,
        };
        if (this.newGisData.length > 0) {
          this.newGisData[this.newGisData.length - 1].colour = value.colour;
        }
      } else if (value && value.type == "Point") {
        this.connectPoints = false;
        this.markerItemInfo = {
          prefix: "",
          suffix: "",
          name: "",
          count: 0,
          installedDate: new Date().toISOString().substr(0, 10),
          installedBy: "",
          labour: 0,
          costPriceExVat: 0,
        };
      } else {
        this.connectPoints = false;
        this.lineItemInfo = {};
        this.markerItemInfo = {};
      }
    },

    async plottingLayer(value) {
      if (value) {
        if (this.newGisData.length > 0) {
          confirm(
            "Are you sure you want to change layers? All unsaved changes will be lost."
          ) &&
            ((this.newGisData = []),
            (this.activePointType = {}),
            (this.activePointTypes = await this.pointTypes.filter(
              (x) => x.gisLayerId == this.plottingLayer.id
            )),
            (this.activePointTypePageStart = 0),
            (this.activePointTypePageEnd = 5),
            (this.viewActivePointTypes = this.activePointTypes.slice(
              this.activePointTypePageStart,
              this.activePointTypePageEnd
            )));
        } else {
          (this.activePointTypes = await this.pointTypes.filter(
            (x) => x.gisLayerId == this.plottingLayer.id
          )),
            (this.activePointTypePageStart = 0),
            (this.activePointTypePageEnd = 5),
            (this.viewActivePointTypes = this.activePointTypes.slice(
              this.activePointTypePageStart,
              this.activePointTypePageEnd
            ));
        }
      }
    },
    async pointTypeSearch(value) {
      if (value) {
        this.activePointTypes = await this.pointTypes.filter(
          (x) =>
            x.gisLayerId == this.plottingLayer.id &&
            x.name.toLowerCase().includes(value)
        );
        this.activePointTypePageStart = 0;
        this.activePointTypePageEnd = 5;
        this.viewActivePointTypes = this.activePointTypes.slice(
          this.activePointTypePageStart,
          this.activePointTypePageEnd
        );
      } else {
        this.activePointTypes = await this.pointTypes.filter(
          (x) => x.gisLayerId == this.plottingLayer.id
        );
        this.activePointTypePageStart = 0;
        this.activePointTypePageEnd = 5;
        this.viewActivePointTypes = this.activePointTypes.slice(
          this.activePointTypePageStart,
          this.activePointTypePageEnd
        );
      }
    },
    async selectedLayers(value) {
      if (value.length > 0) {
        this.selectedPoints = this.pointTypes
          .filter((x) => this.selectedLayers.includes(x.gisLayerId))
          .map((x) => x.id);
        this.pointTypes.map((x) => {
          x.selected = this.selectedPoints.includes(x.id);
        });
        this.filterKey += 1;
      }
    },
    async selectedPoints(value) {
      if (value.length > 0 && this.gisData.length > 0) {
        this.markerArray = this.gisData.filter(
          (x) =>
            x.gisPointType.type == "Point" &&
            !x.gisPointType.isTower &&
            this.selectedPoints.includes(x.gisPointTypeId)
        );
        this.towerArray = this.gisData.filter(
          (x) =>
            x.gisPointType.type == "Point" &&
            x.gisPointType.isTower &&
            this.selectedPoints.includes(x.gisPointTypeId)
        );
        this.lineArray = this.gisData.filter(
          (x) =>
            x.gisPointType.type == "Line" &&
            this.selectedPoints.includes(x.gisPointTypeId)
        );
        this.filterKey += 1;
      }
    },
    selectedNetwork(value) {
      if (value && value.id) {
        this.selectedNode = value.locationNodeId;
      }
    },
    groundLevel(value) {
      if (value != undefined) {
        this.getGISData();
      }
    },
  },

  mounted() {
    //  this.$refs.croppieRef.bind({
    //         url: 'http://i.imgur.com/Fq2DMeH.jpg',
    //     })
    this.geolocate();
  },
  async created() {
    this.$gmapApiPromiseLazy().then(() => {
      this.initialize(); //init once  library has been loaded
    });

    // await this.getNetworkPolygons();
  },

  methods: {
    async initialize() {
      this.groundLevel = 0;
      await this.getGISPointTypes();
      await this.getGISLayers();
      this.getNetworkPolygons();
      this.getGISData();
      this.getLocationData();
      this.initZoomChange();
      this.fetchNetworks();
      this.fetchNodes();
      this.fetchOverlayImages();
    },
    testElev() {
      // The following path marks a path from Mt. Whitney, the highest point in the
      // continental United States to Badwater, Death Valley, the lowest point.
      const path = [
        { lng: -33.919473, lat: 18.427059 },
        { lat: 36.579, lng: -118.292 },
        { lat: 36.606, lng: -118.0638 },
        { lat: 36.433, lng: -117.951 },
        { lat: 36.588, lng: -116.943 },
        { lat: 36.34, lng: -117.468 },
        { lat: 36.24, lng: -116.832 },
      ]; // Badwater, Death Valley
      const map = new google.maps.Map(document.getElementByRef("mapRef"));
      // Create an ElevationService.
    },

    displayPathElevation(path, elevator, map) {
      // Display a polyline of the elevation path.
      new google.maps.Polyline({
        path: path,
        strokeColor: "#0000CC",
        strokeOpacity: 0.4,
        map: map,
      });
      // Create a PathElevationRequest object using this array.
      // Ask for 256 samples along that path.
      // Initiate the path request.
      elevator.getElevationAlongPath({
        path: path,
        samples: 256,
      });
      console.log(
        elevator.getElevationAlongPath({
          path: path,
          samples: 256,
        })
      );
    },

    fetchOverlayImages() {
      Api()
        .get("/gisImageOverlay")
        .then(async (response) => {
          await response.data.forEach((x) => {
            x.bounds = JSON.parse(x.bounds);
          });
          this.allOverlayImages = response.data;
          this.overlayImages = response.data;
          this.imageOverlayKey += 1;
        });
    },
    removeOverlayImage(item) {
      Api()
        .put("/gisImageOverlay/" + item.id)
        .then((response) => {
          console.log(response);
        });
    },
    createOverlayImage(item) {
      console.log(item);
      let obj = {
        img: item.img,
        bounds: JSON.stringify(item.bounds),
        level: "Ground Floor",
      };
      Api()
        .post("/gisImageOverlay", obj)
        .then((response) => {
          console.log(response);
          this.fetchOverlayImages();
        });
    },
    updateItem(item) {
      let array = item.array;
      if (item.newArray) {
        array = item.newArray.map((x) => ({
          lat: x.lat(),
          lng: x.lng(),
        }));
      }
      item.array = array ? JSON.stringify(array) : null;
      if (item.array) {
        let length = google.maps.geometry.spherical.computeLength(item.array);
        length = Math.round(length * 100) / 100;
        let adjustments =
          Math.round(
            length * ((item.helixFactor + item.sagFactor) / 100) * 100
          ) / 100;
        item.calculatedLength = length;
        item.adjustedLength =
          Math.round((item.length + adjustments) * 100) / 100;
      }
      item.lineStart =
        array && array.length > 0 ? JSON.stringify(array[0]) : null;
      item.lineEnd =
        array && array.length > 0
          ? JSON.stringify(array[array.length - 1])
          : null;
      Api()
        .put("/gisData/" + item.id, item)
        .then((response) => {
          let find = this.gisData.find((x) => x.id == item.id);
          let index = this.gisData.indexOf(find);
          this.gisData[index] = item;
          this.editItem = {};
          this.text = item.name + " successfully updated!";
          this.snackbar = true;
        });
    },
    async editItemFunction() {
      this.isEditing = true;
      this.editItem = await this.rightClickWindowData;
      this.editKey += 1;
      this.rightClickWindow = false;
      this.rightClickWindowData = {};
    },
    async showCluster(data) {
      if (data.markers_) {
        let coordArray = [];
        let uniqueArray = [];
        for (let i = 0; i < data.markers_.length; i++) {
          let pos = data.markers_[i].getPosition();
          let id = JSON.stringify(pos.lat()) + JSON.stringify(pos.lng());
          if (!uniqueArray.includes(id)) {
            uniqueArray.push(id);
            coordArray.push({ id: id, lat: pos.lat(), lng: pos.lng() });
          }
        }
        let markers = [];
        for (let i = 0; i < coordArray.length; i++) {
          let filter = await this.markerArray.filter(
            (x) => x.lat == coordArray[i].lat && x.lng == coordArray[i].lng
          );
          markers.push(filter);
        }
        if (markers.length > 1) {
          this.clusterInfoWindowData.markers = markers;
          this.clusterInfoWindowData.center = {
            lat: data.center_.lat(),
            lng: data.center_.lng(),
          };
          this.clusterInfoWindow = true;
          this.clusterKey += 1;
        } else {
          let baseData = markers[0].filter((x) => !x.upstreamGISDataId);
          if (baseData.length == 0) {
            let allUpstreamId = markers[0].map((x) => x.id);
            baseData = markers[0].filter(
              (x) => !allUpstreamId.includes(x.upstreamGISDataId)
            );
          }
          let allData = markers[0];
          for (let a = 0; a < baseData.length; a++) {
            baseData[a].children = [];
          }
          this.clusterHierarchy = baseData;
          this.showClusterHierarchy = true;
        }
      } else {
        let markers = data;
        let baseData = markers.filter((x) => !x.upstreamGISDataId);
        if (baseData.length == 0) {
          let allUpstreamId = markers.map((x) => x.id);
          baseData = markers.filter(
            (x) => !allUpstreamId.includes(x.upstreamGISDataId)
          );
        }
        let allData = markers;
        for (let a = 0; a < baseData.length; a++) {
          baseData[a].children = [];
        }

        this.clusterHierarchy = baseData;
        this.clusterInfoWindow = false;
        this.showClusterHierarchy = true;
        this.clusterKey += 1;
        this.zoom = 21;
        this.center = { lat: baseData[0].lat, lng: baseData[0].lng };
      }
    },
    async fetchAssociatedData(item) {
      return Api()
        .get("/gisData/contents/" + item.id)
        .then((response) => {
          response.data.map((x) => {
            if (x.downStreamCount > 0) {
              x.children = [];
            }
          });
          item.children = response.data;
          if (item.children.length > 0) {
            item.locked = false;
          } else {
            item.locked = true;
            delete item.children;
          }
          this.open.push(item.id);
          this.clusterHierarchykey += 1;
        });
      // return
    },
    async applyFilter() {
      this.markerArray = await this.gisData.filter(
        (x) =>
          x.gisPointType.type == "Point" &&
          this.selectedPoints.includes(x.gisPointTypeId) &&
          (this.filterNodes.includes(x.locationNodeId) ||
            this.filterNetworks.includes(x.locationNetworkId))
      );
      this.lineArray = await this.gisData.filter(
        (x) =>
          x.gisPointType.type == "Line" &&
          this.selectedPoints.includes(x.gisPointTypeId) &&
          (this.filterNodes.includes(x.locationNodeId) ||
            this.filterNetworks.includes(x.locationNetworkId))
      );
      this.filterModal = false;
      // this.selectAllNodes = true
      // this.selectAllNetworks = true
      // this.filterNodes = this.locationNodes.map(x=>x.id)
      // this.filterNetworks = this.locationNetworks.map(x=>x.id)
    },
    async clearFilter() {
      this.markerArray = await this.gisData.filter(
        (x) =>
          x.gisPointType.type == "Point" &&
          this.selectedPoints.includes(x.gisPointTypeId)
      );
      this.lineArray = await this.gisData.filter(
        (x) =>
          x.gisPointType.type == "Line" &&
          this.selectedPoints.includes(x.gisPointTypeId)
      );
      this.selectAllNodes = true;
      this.selectAllNetworks = true;
      this.filterNodes = this.locationNodes.map((x) => x.id);
      this.filterNetworks = this.locationNetworks.map((x) => x.id);
      this.filterModal = false;
    },
    showMarkerInfo(data) {
      if (this.showClusterHierarchy) {
        this.isEditing = true;
      }
      this.showClusterHierarchy = false;
      if (this.isEditing) {
        this.editItem = data;
      } else {
        this.markerInfoWindowData = data;
        this.markerInfoWindow = true;
        this.lineInfoWindow = false;
        this.lineInfoWindowData = {};
        this.key += 1;
      }
    },
    showLocationMarkerInfo(data) {
      if (this.showClusterHierarchy) {
        this.isEditing = true;
      }
      this.showClusterHierarchy = false;
      if (this.isEditing) {
        this.editItem = data;
      } else {
        this.markerInfoWindowData = data;
        this.markerInfoWindow = true;
        this.lineInfoWindow = false;
        this.lineInfoWindowData = {};
        this.key += 1;
      }
    },
    cancelPlotting() {
      confirm(
        "Are you sure you would like to cancel? All unsaved changes will be lost."
      ) && ((this.newGisData = []), (this.isPlotting = false));
    },
    async getReportModal() {
      this.reportData = {
        networkReport: true,
        nodeReport: false,
        reportType: "Bill of Quantities",
        loadingReportKey: 0,
      };
      this.reportModal = true;
    },
    async generateNetworkReport(locationNetworkId) {
      this.reportData.loadingReport = true;
      this.reportData.loadingReportKey += 1;
      await Api()
        .get("/gisData/byNetwork/" + locationNetworkId)
        .then(async (response) => {
          this.reportData.data = response.data;
          this.reportData.loadingReport = false;
          this.reportData.loadingReportKey += 1;
        });
    },
    async generateNodeReport(locationNodeId) {
      this.reportData.loadingReport = true;
      this.reportData.loadingReportKey += 1;
      await Api()
        .get("/gisData/byNode/" + locationNodeId)
        .then(async (response) => {
          this.reportData.data = response.data;
          console.log(this.reportData.data);
          this.reportData.loadingReport = false;
          this.reportData.loadingReportKey += 1;
        });
    },
    async showLineInfo(event, data) {
      this.lineInfoWindow = false;
      if (this.showClusterHierarchy) {
        this.isEditing = true;
      }
      this.showClusterHierarchy = false;
      if (!this.isEditing) {
        this.lineInfoWindowData = data;
        if (!this.isEditing) {
          this.lineInfoWindowData.position = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          };
        }
        this.lineInfoWindowData.tubes = [];

        if (
          this.lineInfoWindowData.gisPointType.hasTubes &&
          this.lineInfoWindowData.gisPointType.tubes > 0
        ) {
          let tubes = await this.getItemTubeContents(this.lineInfoWindowData);
          for (let i = 0; i < this.lineInfoWindowData.gisPointType.tubes; i++) {
            this.lineInfoWindowData.tubes[i] = await tubes.filter(
              (x) => x.tubeColourIndex == i
            );
          }
        }
        this.lineInfoWindowData.length =
          google.maps.geometry.spherical.computeLength(data.array);
        this.lineInfoWindowData.length =
          Math.round(this.lineInfoWindowData.length * 100) / 100;
        this.lineInfoWindow = !this.isEditing;
        this.markerInfoWindow = false;
        this.markerInfoWindowData = {};
      } else {
        this.editItem = data;
        this.editItem.length = google.maps.geometry.spherical.computeLength(
          data.array
        );
        this.editItem.length = Math.round(this.editItem.length * 100) / 100;
      }
    },
    async getItemTubeContents(item) {
      let result = [];
      await Api()
        .get("/gisData/contents/" + item.id)
        .then((response) => {
          result = response.data;
        });
      return result;
    },
    snapToLineFunction(event, item) {
      if (this.isInsideConnectionPoint) {
        if (item.gisPointType.hasTubes && item.gisPointType.tubes > 1) {
          this.snapToLineInfo = item;
          this.snapToLineInfo.position = event.latLng;
          this.snapToLineInfoWindow = true;
          this.key += 1;
        } else if (item.gisPointType.hasTubes && item.gisPointType.tubes == 1) {
          this.snapToLineInfo = item;
          this.snapToLineInfo.position = event.latLng;
          this.selectTube(1);
        }
      } else {
        this.newGisData.push({
          colour: this.activePointType.colour,
          name: this.activePointType.name,
          type: "Line",
          waypoints: [],
          data: item.array,
        });
      }
    },
    selectTube(tube) {
      this.newGisData.push({
        colour: this.activePointType.colour,
        name: this.activePointType.name,
        type: "Line",
        waypoints: [],
        data: this.snapToLineInfo.array,
        upstreamGISDataId: this.snapToLineInfo.id,
        tubeColourIndex: tube - 1,
      });
      this.snapToLineInfoWindow = false;
      this.snapToLineInfo = {};
    },
    deleteGISItem(item) {
      confirm("Are you sure you want to delete " + item.name + "?") &&
        Api()
          .put("/gisData/" + item.id, { isActive: false, isDeleted: true })
          .then(async (response) => {
            // let find = this.gisData.find((x) => x.id == item.id);
            // let index = this.gisData.indexOf(find);
            // this.gisData.splice(index, 1);
            this.lineInfoWindow = false;
            this.markerInfoWindow = false;
            this.rightClickWindow = false;
            this.rightClickWindowData = {};
            this.isEditing = false;
            this.text = item.name + " successfully deleted!";
            this.snackbar = true;
            this.getGISData();
            // this.markerArray = await this.gisData.filter(
            //   (x) =>
            //     x.gisPointType.type == "Point" &&
            //     this.selectedLayers.includes(x.gisPointType.gisLayerId)
            // );
            // this.lineArray = await this.gisData.filter(
            //   (x) =>
            //     x.gisPointType.type == "Line" &&
            //     this.selectedLayers.includes(x.gisPointType.gisLayerId)
            // );
          });
    },
    fetchNetworks() {
      Api()
        .get("/locationNetworks")
        .then((response) => {
          this.locationNetworks = response.data;
          this.filterNetworks = this.locationNetworks.map((x) => x.id);
        });
    },
    fetchNodes() {
      Api()
        .get("/locationNodes")
        .then((response) => {
          this.locationNodes = response.data;
          this.filterNodes = this.locationNodes.map((x) => x.id);
        });
    },
    addNewGisDataPoint(point) {
      // this.newGisData[this.newGisData.length - 1].data[
      //   this.newGisData[this.newGisData.length - 1].data.length - 1
      // ] = new google.maps.LatLng(point.lat, point.lng);
      this.newGisData[this.newGisData.length - 1].data.push(
        new google.maps.LatLng(point.lat, point.lng)
      );
      if (
        this.connectPoints &&
        this.connectToPoint &&
        this.connectToPoint.id == point.gisPointTypeId &&
        this.newGisData[this.newGisData.length - 1].data.length > 1
      ) {
        this.newGisData[this.newGisData.length - 1].downstreamGisPointId =
          point.id;
        this.newLine();
      } else if (
        this.connectPoints &&
        this.connectFromPoint &&
        this.connectFromPoint.id == point.gisPointTypeId
      ) {
        this.newGisData[this.newGisData.length - 1].upstreamGisPointId =
          point.id;
        // this.newLine();
      }

      this.multiplePointWindow = false;
    },
    addNewMarkerGisDataPoint(point) {
      if (point.id) {
        if (this.activePointType.type == "Line") {
          if (this.newGisData.length > 0) {
            (this.newGisData[this.newGisData.length - 1].upstreamGISDataId =
              this.isInsideConnectionPoint ? point.id : null),
              this.newGisData[this.newGisData.length - 1].data.push(
                new google.maps.LatLng(point.lat, point.lng)
              );
            if (
              this.connectPoints &&
              this.connectToPoint &&
              this.connectToPoint.id == point.gisPointTypeId &&
              this.newGisData[this.newGisData.length - 1].data.length > 1
            ) {
              this.newLine();
            }
          } else {
            this.newGisData.push({
              type: "Line",
              upstreamGISDataId: this.isInsideConnectionPoint ? point.id : null,
              isEditing: true,
              colour: this.activePointType.colour,
              data: [{ lat: point.lat, lng: point.lng }],
            });
          }
        }
      }
    },
    toggleFullscreenmode() {
      this.$refs["fullscreen"].toggle();
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    async getNetworkPolygons() {
      await Api()
        .get("/locationNetworkPolygon/ownNetworks")
        .then(async (response) => {
          let geoObj = {
            type: "FeatureCollection",
            name: "Network Polygons",
            crs: {
              type: "name",
              properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
            },
            features: [],
          };
          let objects = response.data;
          for (let x = 0; x < objects.length; x++) {
            let obj = {
              type: "Feature",
              properties: {
                name: objects[x].locationNetwork
                  ? objects[x].locationNetwork.name
                  : objects[x].name,
                fno: objects[x].organisation,
                network: objects[x],
                description: null,
                units: objects[x].locationNetwork
                  ? objects[x].locationNetwork.numberOfUnits
                  : objects[x].numberOfUnits,
                tessellate: 1,
              },
              geometry: {
                type: "Polygon",
                coordinates: objects[x].coordinates
                  ? JSON.parse(objects[x].coordinates)
                  : [],
              },
            };
            if (obj.geometry.coordinates.length > 0) {
              if (
                obj.geometry.coordinates[0][0][0] !==
                  obj.geometry.coordinates[0][
                    obj.geometry.coordinates[0].length - 1
                  ][0] ||
                obj.geometry.coordinates[0][0][1] !==
                  obj.geometry.coordinates[0][
                    obj.geometry.coordinates[0].length - 1
                  ][1]
              ) {
                obj.geometry.coordinates[0].push(
                  obj.geometry.coordinates[0][0]
                );
              }
              geoObj.features.push(obj);
            }
          }
          this.networkPolygons = geoObj;
          console.log(this.networkPolygons);
          this.plotMap();
        });
    },
    getLocationData() {
      Api()
        .get("/gisData/locations/all")
        .then((response) => {
          this.locationDataPoints = response.data;
        });
    },
    getGISData() {
      this.loadingGisData = true;
      Api()
        .get("/gisData/" + this.groundLevel)
        .then(async (response) => {
          let data = response.data;
          await data.map(async (x) => {
            if (x.array && typeof x.array == "string" && x.array != "NULL") {
              let tempArray = JSON.parse(x.array);
              if (tempArray && tempArray.length > 0) {
                tempArray = await tempArray.map(
                  (y) => new google.maps.LatLng(y)
                );
                x.array = tempArray;
              }
            } else if (typeof x.lat == "string" || typeof x.lng == "string") {
              x.lat = parseFloat(x.lat);
              x.lng = parseFloat(x.lng);
            }
          });
          this.gisData = data;
          this.markerArray = this.gisData.filter(
            (x) =>
              x.gisPointType.type == "Point" &&
              !x.gisPointType.isTower &&
              this.selectedLayers.includes(x.gisPointType.gisLayerId)
          );
          await this.markerArray.map((x) => {
            x.lat = parseFloat(x.lat);
            x.lng = parseFloat(x.lng);
          });
          this.towerArray = this.gisData.filter(
            (x) =>
              x.gisPointType.type == "Point" &&
              x.gisPointType.isTower &&
              this.selectedLayers.includes(x.gisPointType.gisLayerId)
          );
          this.lineArray = this.gisData.filter(
            (x) =>
              x.gisPointType.type == "Line" &&
              this.selectedLayers.includes(x.gisPointType.gisLayerId)
          );

          this.loadingGisData = false;
        });
    },
    getGISPointTypes() {
      Api()
        .get("/gisPointType")
        .then(async (response) => {
          this.selectedPoints = response.data.map((x) => x.id);
          let data = response.data;
          await data.forEach((x) => {
            x.selected = true;
          });
          this.pointTypes = data;
        });
    },
    getGISLayers() {
      Api()
        .get("/gisLayer")
        .then(async (response) => {
          this.selectedLayers = response.data.map((x) => x.id);
          let data = response.data;
          await data.forEach((x) => {
            x.selected = true;
          });
          this.layerItems = data;
        });
    },
    rightClickHandler(e, item) {
      console.log(item);
      e.preventDefault();
      this.rightClickWindowData = item;
      this.rightClickWindowData.center = { lat: item.lat, lng: item.lng };
      this.rightClickWindow = true;
      console.log("Right click!");
    },
    rightClickPolyHandler(data) {
      console.log(data);
    },
    undoLastPoint() {
      if (this.activePointType.type == "Line") {
        this.newGisData[this.newGisData.length - 1].data.pop();
      } else if (this.activePointType.type == "Point") {
        this.newGisData.pop();
      }
    },
    setPlotType(type) {
      this.activePlotType = type;
    },
    setPointType(type) {
      this.activePointType = type;
    },
    updatePolyData(data) {
      let keys = Object.keys(data);
      this.polyData = data[keys[0]][0].keys[0];
    },
    getPolyBounds(data) {
      this.imageBounds = data;
    },
    addPolyBounds(data) {
      this.newImageOverlay.bounds = data;
      this.imageOverlayKey += 1;
    },
    rectangeDragStart() {
      this.imageOverlays = [];
      this.showOverlays = false;
      this.imageOverlayKey += 1;
    },
    async updateRectangleBounds(event, data) {
      let find = await this.allOverlayImages.find((x) => x.id == data.id);
      let index = await this.allOverlayImages.indexOf(find);
      this.allOverlayImages[index].bounds = event;
      console.log(event);

      this.imageOverlayKey += 1;
    },
    async updateRectangleDragend(event, data) {
      this.imageOverlays = this.allOverlayImages;
      console.log(this.allOverlayImages);
      this.showOverlays = true;
      this.imageOverlayKey += 1;
    },
    async updateLineData(data, item, lineIndex) {
      let keys = Object.keys(data);
      console.log(data);
      console.log(item);
      let editedPoint = null;
      let newData = null;
      let index = null;
      let lat = null;
      let lng = null;
      await item.array.forEach(async (x, idx) => {
        let find = await data[keys[0]].find(
          (y) => y.lat() == x.lat() && y.lng() == x.lng()
        );
        if (!find) {
          editedPoint = x;
          index = idx;
          newData = data[keys[0]][index];
        }
      });
      if (this.snapToPointCheck && this.snapPointType) {
        let markers = await this.gisData.filter(
          (x) => x.gisPointTypeId == this.snapPointType.id
        );
        let nearbyMarkers = [];
        for (let i = 0; i < markers.length; i++) {
          let dist = google.maps.geometry.spherical.computeDistanceBetween(
            new google.maps.LatLng(markers[i].lat, markers[i].lng),
            new google.maps.LatLng(newData.lat(), newData.lng())
          );
          if (dist < 50) {
            markers[i].dist = dist;
            nearbyMarkers.push(markers[i]);
          }
        }
        this.nearbyPoints = nearbyMarkers;
        if (nearbyMarkers.length == 1) {
          lat = nearbyMarkers[0].lat;
          lng = nearbyMarkers[0].lng;
          item.array[index] = await new google.maps.LatLng(lat, lng);
          this.lineArray[lineIndex].array = item.array;
          this.updateLineDatakey += 1;
        } else if (nearbyMarkers.length > 1) {
          let distances = this.nearbyPoints.map((x) => x.dist);
          let minPoint = Math.min(...distances);
          let closestPoint = this.nearbyPoints.find((x) => x.dist == minPoint);
          item.array[index] = new google.maps.LatLng(
            closestPoint.lat,
            closestPoint.lng
          );
          this.lineArray[lineIndex].array = item.array;
          this.updateLineDatakey += 1;
        }
        this.lineInfoWindowData.newArray = item.array;
      } else {
        this.lineInfoWindowData.newArray = keys[0];
        this.lineInfoWindowData.array = keys[0];
        this.lineArray[lineIndex].array = keys[0];

        this.updateLineDatakey += 1;
      }

      this.lineInfoWindowData.length =
        google.maps.geometry.spherical.computeLength(
          this.lineInfoWindowData.newArray
        );
      this.lineInfoWindowData.length =
        Math.round(this.lineInfoWindowData.length * 100) / 100;
      this.updatedLength += 1;
    },
    async updateNewLineData(data, line) {
      console.log(data);
      let keys = Object.keys(data);
      line.data = data[keys[0]];
      let length = google.maps.geometry.spherical.computeLength(line.data);
      this.lineItemInfo.length = Math.round(length * 100) / 100;
      let adjustments =
        Math.round(
          this.lineItemInfo.length *
            ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
              100) *
            100
        ) / 100;
      this.lineItemInfo.adjustedLength =
        Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
    },
    manuallyAddPoint(point) {
      this.newGisData.push({
        id: new Date().getTime(),
        type: "Point",
        colour: this.activePointType.colour,
        icon: this.activePointType.icon,
        position: { lat: point.lat, lng: point.lng },
      });
      this.manualPoint = {};
    },
    plotPositions(data) {
      if (this.isPlotting && this.connectPoints) {
        this.connectPositions(data);
      } else if (this.isPlotting) {
        this.addPosition(data);
      } else if (this.plottingImageOverlay) {
        if (this.newImageOverlay.bounds) {
          this.newImageOverlay.bounds.push(data.latLng);
        } else {
          this.newImageOverlay.bounds = [data.latLng];
        }
        this.imageOverlayKey += 1;
      }
    },
    async testLOS(data) {
      console.log(data);
      await Api()
        .post("/gis/feasibility", {
          lat: data.latLng.lat().toString(),
          lng: data.latLng.lng().toString(),
        })
        .then((res) => {
          this.lineOfSightItem = res.data;
          this.lineOfSightModal = true;
        });
    },
    async testLocationLOS(latLng) {
      this.placeInfoWindow.isLoading = true;
      this.placeInfoWindow.key += 1;
      this.lineOfSightItem = [];
      this.lineOfSightItem = false;
      await Api()
        .post("/gis/feasibility", {
          lat: latLng.lat().toString(),
          lng: latLng.lng().toString(),
        })
        .then((res) => {
          this.placeInfoWindow.isLoading = false;
          this.placeInfoWindow.key += 1;
          this.lineOfSightItem = res.data;
          this.lineOfSightModal = true;
        });
    },
    testData(data) {
      let max = Math.max(...data.map((x) => x[1]));
      let result = false;
      if (data[0][1] >= data[data.length - 1][1] && data[0][1] >= max) {
        result = true;
      } else if (
        data[0][1] <= data[data.length - 1][1] &&
        data[data.length - 1][1] >= max
      ) {
        result = true;
      }

      data = [
        { name: "Elevation", data: data },
        { name: "LOS", data: [max, data[data.length - 1][1]] },
      ];
      this.lineOfSightItem.result = result;
      this.lineOfSightItem.max = max;
      return data;
    },
    async connectPositions(data) {
      let lat = data.latLng.lat();
      let lng = data.latLng.lng();

      if (this.connectFromPoint && this.connectToPoint) {
        let markers = [];
        if (
          this.newGisData.length == 0 ||
          this.newGisData[this.newGisData.length - 1].data.length == 0
        ) {
          markers = await this.markerArray.filter(
            (x) => x.gisPointTypeId == this.connectFromPoint.id
          );
        } else if (
          this.newGisData.length > 0 &&
          this.newGisData[this.newGisData.length - 1].data.length > 0
        ) {
          markers = await this.markerArray.filter(
            (x) => x.gisPointTypeId == this.connectToPoint.id
          );
        } else {
          markers = await this.markerArray.filter(
            (x) =>
              x.gisPointTypeId == this.connectFromPoint.id ||
              x.gisPointTypeId == this.connectToPoint.id
          );
        }

        let nearbyMarkers = [];
        for (let i = 0; i < markers.length; i++) {
          let dist = google.maps.geometry.spherical.computeDistanceBetween(
            new google.maps.LatLng(markers[i].lat, markers[i].lng),
            new google.maps.LatLng(data.latLng.lat(), data.latLng.lng())
          );
          if (dist < 50) {
            markers[i].dist = dist;
            nearbyMarkers.push(markers[i]);
          }
        }
        this.nearbyPoints = nearbyMarkers;
        if (this.newGisData.length > 0 && nearbyMarkers.length == 1) {
          lat = nearbyMarkers[0].lat;
          lng = nearbyMarkers[0].lng;
          if (this.newGisData[this.newGisData.length - 1].data.length > 0) {
            this.newGisData[this.newGisData.length - 1].downstreamGisPointId =
              nearbyMarkers[0].id;
          } else {
            this.newGisData[this.newGisData.length - 1].upstreamGisPointId =
              nearbyMarkers[0].id;
          }
          // this.newGisData[this.newGisData.length-1].waypoints.push(new google.maps.LatLng(lat, lng))
          this.newGisData[this.newGisData.length - 1].data.push(
            new google.maps.LatLng(lat, lng)
          );
          let dist = google.maps.geometry.spherical.computeLength(
            this.newGisData[this.newGisData.length - 1].data
          );
          this.lineItemInfo.length = Math.round(dist * 100) / 100;
          let adjustments =
            Math.round(
              this.lineItemInfo.length *
                ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
                  100) *
                100
            ) / 100;
          this.lineItemInfo.adjustedLength =
            Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
          // this.newLine()
        } else if (this.newGisData.length > 0 && nearbyMarkers.length > 1) {
          this.newGisData[this.newGisData.length - 1].data.push(
            new google.maps.LatLng(lat, lng)
          );
          this.multiplePointWindow = true;
          this.showMarkerLabels = true;
          this.clusterGISPoints = false;
          let dist = google.maps.geometry.spherical.computeLength(
            this.newGisData[this.newGisData.length - 1].data
          );
          this.lineItemInfo.length = Math.round(dist * 100) / 100;
          let adjustments =
            Math.round(
              this.lineItemInfo.length *
                ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
                  100) *
                100
            ) / 100;
          this.lineItemInfo.adjustedLength =
            Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
        } else if (this.newGisData.length == 0 && nearbyMarkers.length > 1) {
          this.newGisData.push({
            type: "Line",
            isEditing: true,
            colour: this.activePointType.colour,
            data: [new google.maps.LatLng(lat, lng)],
            waypoints: [new google.maps.LatLng(lat, lng)],
          });
          let dist = google.maps.geometry.spherical.computeLength(
            this.newGisData[this.newGisData.length - 1].data
          );
          this.lineItemInfo.length = Math.round(dist * 100) / 100;
          let adjustments =
            Math.round(
              this.lineItemInfo.length *
                ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
                  100) *
                100
            ) / 100;
          this.lineItemInfo.adjustedLength =
            Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
          this.multiplePointWindow = true;
        } else if (this.newGisData.length == 0 && nearbyMarkers.length == 1) {
          lat = nearbyMarkers[0].lat;
          lng = nearbyMarkers[0].lng;

          this.newGisData.push({
            type: "Line",
            isEditing: true,
            colour: this.activePointType.colour,
            data: [new google.maps.LatLng(lat, lng)],
            waypoints: [new google.maps.LatLng(lat, lng)],
          });
          if (this.newGisData[this.newGisData.length - 1].data.length > 0) {
            this.newGisData[this.newGisData.length - 1].downstreamGisPointId =
              nearbyMarkers[0].id;
          } else {
            this.newGisData[this.newGisData.length - 1].upstreamGisPointId =
              nearbyMarkers[0].id;
          }
          let dist = google.maps.geometry.spherical.computeLength(
            this.newGisData[this.newGisData.length - 1].data
          );
          this.lineItemInfo.length = Math.round(dist * 100) / 100;
          let adjustments =
            Math.round(
              this.lineItemInfo.length *
                ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
                  100) *
                100
            ) / 100;
          this.lineItemInfo.adjustedLength =
            Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
        } else if (this.newGisData.length == 0) {
          this.newGisData.push({
            type: "Line",
            isEditing: true,
            colour: this.activePointType.colour,
            data: [new google.maps.LatLng(lat, lng)],
            waypoints: [new google.maps.LatLng(lat, lng)],
          });
          let dist = google.maps.geometry.spherical.computeLength(
            this.newGisData[this.newGisData.length - 1].data
          );
          this.lineItemInfo.length = Math.round(dist * 100) / 100;
          let adjustments =
            Math.round(
              this.lineItemInfo.length *
                ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
                  100) *
                100
            ) / 100;
          this.lineItemInfo.adjustedLength =
            Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
        }
      } else if (this.snapToPointCheck) {
      }
    },
    async addPosition(data) {
      if (this.activePointType.type == "Polygon") {
        this.newGisData.push({
          type: "Polygon",
          colour: this.activePointType.colour,
          data: new google.maps.LatLng(data.latLng.lat(), data.latLng.lng()),
        });
      } else if (this.activePointType.type == "Line") {
        let lat = data.latLng.lat();
        let lng = data.latLng.lng();
        if (this.snapToPointCheck && this.snapPointType) {
          let markers = await this.markerArray.filter(
            (x) => x.gisPointTypeId == this.snapPointType.id
          );
          let nearbyMarkers = [];
          for (let i = 0; i < markers.length; i++) {
            let dist = google.maps.geometry.spherical.computeDistanceBetween(
              new google.maps.LatLng(markers[i].lat, markers[i].lng),
              new google.maps.LatLng(data.latLng.lat(), data.latLng.lng())
            );
            if (dist < 50) {
              markers[i].dist = dist;
              nearbyMarkers.push(markers[i]);
            }
          }
          this.nearbyPoints = nearbyMarkers;
          if (nearbyMarkers.length == 1) {
            lat = nearbyMarkers[0].lat;
            lng = nearbyMarkers[0].lng;
            if (this.newGisData.length > 0) {
              this.newGisData[this.newGisData.length - 1].data.push(
                new google.maps.LatLng(lat, lng)
              );
            } else {
              this.newGisData.push({
                type: "Line",
                isEditing: true,
                colour: this.activePointType.colour,
                data: [{ lat: lat, lng: lng }],
              });
            }

            let dist = google.maps.geometry.spherical.computeLength(
              this.newGisData[this.newGisData.length - 1].data
            );
            this.lineItemInfo.length = Math.round(dist * 100) / 100;
            let adjustments =
              Math.round(
                this.lineItemInfo.length *
                  ((this.lineItemInfo.helixFactor +
                    this.lineItemInfo.sagFactor) /
                    100) *
                  100
              ) / 100;
            this.lineItemInfo.adjustedLength =
              Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
          } else if (nearbyMarkers.length == 0) {
            this.newGisData[this.newGisData.length - 1].data.push(
              new google.maps.LatLng(lat, lng)
            );
            let dist = google.maps.geometry.spherical.computeLength(
              this.newGisData[this.newGisData.length - 1].data
            );
            this.lineItemInfo.length = Math.round(dist * 100) / 100;
            let adjustments =
              Math.round(
                this.lineItemInfo.length *
                  ((this.lineItemInfo.helixFactor +
                    this.lineItemInfo.sagFactor) /
                    100) *
                  100
              ) / 100;
            this.lineItemInfo.adjustedLength =
              Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
          } else {
            this.newGisData[this.newGisData.length - 1].data.push(
              new google.maps.LatLng(lat, lng)
            );
            this.multiplePointWindow = true;
            let dist = google.maps.geometry.spherical.computeLength(
              this.newGisData[this.newGisData.length - 1].data
            );
            this.lineItemInfo.length = Math.round(dist * 100) / 100;
            let adjustments =
              Math.round(
                this.lineItemInfo.length *
                  ((this.lineItemInfo.helixFactor +
                    this.lineItemInfo.sagFactor) /
                    100) *
                  100
              ) / 100;
            this.lineItemInfo.adjustedLength =
              Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
          }
        } else if (this.newGisData.length > 0) {
          this.newGisData[this.newGisData.length - 1].data.push(
            new google.maps.LatLng(lat, lng)
          );
          let dist = google.maps.geometry.spherical.computeLength(
            this.newGisData[this.newGisData.length - 1].data
          );
          this.lineItemInfo.length = Math.round(dist * 100) / 100;
          let adjustments =
            Math.round(
              this.lineItemInfo.length *
                ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
                  100) *
                100
            ) / 100;
          this.lineItemInfo.adjustedLength =
            Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
        } else {
          this.newGisData.push({
            type: "Line",
            colour: this.activePointType.colour,
            isEditing: true,
            data: [new google.maps.LatLng(lat, lng)],
          });
          let dist = google.maps.geometry.spherical.computeLength(
            this.newGisData[this.newGisData.length - 1].data
          );
          this.lineItemInfo.length = Math.round(dist * 100) / 100;
          let adjustments =
            Math.round(
              this.lineItemInfo.length *
                ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
                  100) *
                100
            ) / 100;
          this.lineItemInfo.adjustedLength =
            Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
        }
      } else if (this.activePointType.type == "Point") {
        let lat = data.latLng.lat();
        let lng = data.latLng.lng();
        let point = new google.maps.LatLng(lat, lng);

        let edgePolylines = [];
        // for (let x = 0; x < this.lineArray.length; x++) {
        //   var polyline = await new google.maps.Polyline({
        //     path: this.lineArray[x].array,
        //   });
        //   let isOnEdge = await google.maps.geometry.poly.isLocationOnEdge(
        //     point,
        //     polyline,
        //     0.0002
        //   );
        //   if (isOnEdge) {
        //     edgePolylines.push(this.lineArray[x]);
        //   }
        // }
        // await this.lineArray.map(async x=>{

        // })
        // let isOnLine =
        if (this.snapToPointCheck && this.snapPointType) {
          let markers = await this.gisData.filter(
            (x) => x.gisPointTypeId == this.snapPointType.id
          );
          let nearbyMarkers = [];
          for (let i = 0; i < markers.length; i++) {
            let dist = google.maps.geometry.spherical.computeDistanceBetween(
              new google.maps.LatLng(markers[i].lat, markers[i].lng),
              new google.maps.LatLng(data.latLng.lat(), data.latLng.lng())
            );
            if (dist < 50) {
              markers[i].dist = dist;
              nearbyMarkers.push(markers[i]);
            }
          }
          this.nearbyPoints = nearbyMarkers;
          if (nearbyMarkers.length == 1) {
            lat = nearbyMarkers[0].lat;
            lng = nearbyMarkers[0].lng;
            this.newGisData.push({
              type: "Point",
              name:
                this.markerItemInfo.prefix +
                this.markerItemInfo.count.toString() +
                this.markerItemInfo.suffix,
              installedDate: this.markerItemInfo.installedDate,
              installedBy: this.markerItemInfo.installedBy,
              colour: this.activePointType.colour,
              icon: this.activePointType.icon,
              level: 0,
              upstreamGISDataId: this.isInsideConnectionPoint
                ? nearbyMarkers[0].id
                : null,
              position: { lat: lat, lng: lng },
            });
          } else if (nearbyMarkers.length == 0) {
            this.newGisData.push({
              type: "Point",
              name:
                this.markerItemInfo.prefix +
                this.markerItemInfo.count.toString() +
                this.markerItemInfo.suffix,
              installedDate: this.markerItemInfo.installedDate,
              installedBy: this.markerItemInfo.installedBy,
              colour: this.activePointType.colour,
              icon: this.activePointType.icon,
              upstreamGISDataId: null,
              level: 0,
              position: { lat: lat, lng: lng },
            });
          } else {
            this.newGisData.push({
              type: "Point",
              name:
                this.markerItemInfo.prefix +
                this.markerItemInfo.count.toString() +
                this.markerItemInfo.suffix,
              installedDate: this.markerItemInfo.installedDate,
              installedBy: this.markerItemInfo.installedBy,
              colour: this.activePointType.colour,
              icon: this.activePointType.icon,
              level: 0,
              position: { lat: lat, lng: lng },
            });
            this.multiplePointWindow = true;
          }
        } else {
          this.newGisData.push({
            id: new Date().getTime(),
            type: "Point",
            name:
              this.markerItemInfo.prefix +
              this.markerItemInfo.count.toString() +
              this.markerItemInfo.suffix,
            installedDate: this.markerItemInfo.installedDate,
            installedBy: this.markerItemInfo.installedBy,
            colour: this.activePointType.colour,
            icon: this.activePointType.icon,
            level: 0,
            position: { lat: data.latLng.lat(), lng: data.latLng.lng() },
          });
        }
        this.markerItemInfo.count = parseInt(this.markerItemInfo.count);
        this.markerItemInfo.count += 1;
      }
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address = addressData;
    },
    getKMZ() {
      Api()
        .post("/downloadKML", this.coordinates)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "coverage_map.kml");
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },
    // async getNetworkPolygons() {
    //   await Api()
    //     .get("/locationNetworkPolygon/ownNetworks")
    //     .then(async (response) => {
    //       let geoObj = {
    //         type: "FeatureCollection",
    //         name: "Network Polygons",
    //         crs: {
    //           type: "name",
    //           properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
    //         },
    //         features: [],
    //       };
    //       geoObj.features = await response.data.map((x) => ({
    //         type: "Feature",
    //         properties: {
    //           name: x.locationNetwork.name,
    //           fno: x.organisation,
    //           network: x.locationNetwork,
    //           description: null,
    //           units: x.locationNetwork.numberOfUnits,
    //           connected: x.locationNetwork.connectedUnits,
    //           tessellate: 1,
    //         },
    //         geometry: {
    //           type: "Polygon",
    //           coordinates: JSON.parse(x.coordinates),
    //         },
    //       }));
    //       this.geoData = geoObj;
    //       this.plotMap();
    //     });
    // },
    plotMap() {
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.initMapAutocomplete();
        this.map = map;
        this.initZoomChange();

        this.map.data.addGeoJson(this.networkPolygons);
        this.map.data.setStyle(function (feature) {
          let color = "orange";
          let keys = Object.keys(feature);
          let find = keys.find((x) => {
            return typeof feature[x] == "object" && feature[x].network;
          });
          if (
            feature[find] &&
            feature[find].network.locationNetwork.networkStatus === "Live"
          ) {
            color = "#3dc431";
          } else if (
            feature[find] &&
            feature[find].network.locationNetwork.networkStatus ===
              "In Progress"
          ) {
            color = "blue";
          } else if (
            feature[find] &&
            feature[find].network.locationNetwork.networkStatus === "Planned"
          ) {
            color = "orange";
          }
          return {
            fillColor: color,
            fillOpacity: 0.3,
            strokeWeight: 2,
            strokeColor: color,
            styles: {
              featureType: "poi",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
          };
          // return {
          //   fillColor: feature.i.fno.primaryColour,
          //   fillOpacity: 0.3,
          //   strokeWeight: 2,
          //   strokeColor: feature.i.fno.primaryColour,

          // };
        });
        this.map.data.addListener("click", (event) => {
          let area = google.maps.geometry.spherical.computeArea(
            event.feature.g.g[0].g
          );
          this.polyInfo = {
            type: "Network",
            name: event.feature.i.name,
            units: event.feature.i.units,
            connected: event.feature.i.connected,
            fno: event.feature.i.fno,
            network: event.feature.i.network,
            center: event.latLng,
            area: Math.round((area / 1000000) * 100) / 100,
          };
          this.polyInfoWindow = true;
          this.openWindow(event);
        });
        this.map.data.addListener("rightclick", (event) => {
          // console.log(event)
        });
      });
    },
    isWithinPoly(event) {
      var isWithinPolygon = google.maps.geometry.poly.containsLocation(
        event.latLng,
        this
      );
    },
    openWindow(data) {
      this.infoWindowPos = {
        lat: data.latLng.lat(),
        lng: data.latLng.lng(),
      };
      this.infoWinOpen = true;
    },
    pageDown() {
      this.activePointTypePageStart -= 1;
      this.activePointTypePageEnd -= 1;
      this.viewActivePointTypes = this.activePointTypes.slice(
        this.activePointTypePageStart,
        this.activePointTypePageEnd
      );
    },
    pageUp() {
      this.activePointTypePageStart += 1;
      this.activePointTypePageEnd += 1;
      this.viewActivePointTypes = this.activePointTypes.slice(
        this.activePointTypePageStart,
        this.activePointTypePageEnd
      );
    },
    async newLine() {
      console.log(this.lineItemInfo);
      console.log(this.newGisData);
      let length = google.maps.geometry.spherical.computeLength(
        this.newGisData[this.newGisData.length - 1].data
      );
      this.lineItemInfo.length = Math.round(length * 100) / 100;
      let adjustments =
        Math.round(
          this.lineItemInfo.length *
            ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
              100) *
            100
        ) / 100;
      this.lineItemInfo.adjustedLength =
        Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;

      let index = this.newGisData.length - 1;
      this.newGisData[this.newGisData.length - 1].isEditing = false;
      this.newGisData[this.newGisData.length - 1].name = this.lineItemInfo.name;
      this.newGisData[this.newGisData.length - 1].assetTag =
        this.lineItemInfo.assetTag;
      this.newGisData[this.newGisData.length - 1].helixFactor =
        this.lineItemInfo.helixFactor;
      this.newGisData[this.newGisData.length - 1].sagFactor =
        this.lineItemInfo.sagFactor;
      this.newGisData[this.newGisData.length - 1].installedBy =
        this.lineItemInfo.installedBy;
      this.newGisData[this.newGisData.length - 1].installedDate =
        this.lineItemInfo.installedDate;
      this.newGisData[this.newGisData.length - 1].gisPointTypeId =
        this.activePointType.id;
      this.newGisData[this.newGisData.length - 1].costPriceExVat =
        this.lineItemInfo.costPriceExVat;
      this.newGisData[this.newGisData.length - 1].costPriceExVatPerMetre =
        this.lineItemInfo.costPriceExVatPerMetre;
      this.newGisData[this.newGisData.length - 1].labour =
        this.lineItemInfo.labour;
      this.newGisData[this.newGisData.length - 1].labourPerMetre =
        this.lineItemInfo.labourPerMetre;
      this.newGisData[this.newGisData.length - 1].calculatedLength =
        this.lineItemInfo.adjustedLength;
      (this.newGisData[this.newGisData.length - 1].upstreamGISDataId =
        this.isInsideConnectionPoint && this.snapPointType
          ? this.snapPointType.id
          : null),
        (this.newGisData[this.newGisData.length - 1].locationNetworkId = this
          .selectedNetwork
          ? this.selectedNetwork.id
          : null),
        (this.newGisData[this.newGisData.length - 1].locationNodeId =
          this.selectedNode);

      this.newGisData[this.newGisData.length - 1].level = this.selectedLevel;

      if (this.mapToRoad) {
        let routeService = await new google.maps.DirectionsService();
        await routeService.route(
          {
            origin: this.newGisData[index].data[0],
            destination:
              this.newGisData[index].data[
                this.newGisData[index].data.length - 1
              ],
            travelMode: google.maps.DirectionsTravelMode.DRIVING,
          },
          async (result, status) => {
            if (status == google.maps.DirectionsStatus.OK) {
              let newRoutes = [];
              let routes = result.routes[0].overview_path;
              await routes.forEach(async (x, index) => {
                if (index != 0 && index != routes.length - 1) {
                  // let newPoint = await google.maps.geometry.spherical.computeOffset(
                  //   x,
                  //   5,
                  //   90
                  // );
                  newRoutes.push(x);
                }
              });
              newRoutes[0] = this.newGisData[index].data[0];
              newRoutes[newRoutes.length - 1] =
                this.newGisData[index].data[
                  this.newGisData[index].data.length - 1
                ];
              this.newGisData[index].data = newRoutes;
              this.newGisData[index].isEditing = true;
              this.newGisData[index].lineStart = JSON.stringify(
                this.newGisData[index].data[0]
              );
              this.newGisData[index].lineEnd = JSON.stringify(
                this.newGisData[index].data[
                  this.newGisData[index].data.length - 1
                ]
              );
              this.newGisData[index].array = JSON.stringify(
                this.newGisData[index].data
              );
              this.lineItemInfo.calculatedLength =
                Math.round(
                  google.maps.geometry.spherical.computeLength(
                    this.newGisData[index].data
                  ) * 100
                ) / 100;
              this.lineItemInfo.adjustedLength =
                Math.round(
                  this.lineItemInfo.length +
                    this.lineItemInfo.length *
                      (this.lineItemInfo.helixFactor +
                        this.lineItemInfo.sagFactor) *
                      100
                ) / 100;
              this.lineItemInfo = {
                name: this.activePointType.name,
                helixFactor: 2,
                sagFactor: 0,
                length: 0,
                adjustedLength: 0,
                costPriceExVatPerMetre: 0,
                costPriceExVat: 0,
                labour: 0,
                labourPerMetre: 0,
                labourChargedPerM: true,
              };
              this.newGisData.push({
                colour: this.activePointType.colour,
                name: null,
                type: "Line",
                waypoints: [],
                data: [
                  this.newGisData[index].data[
                    this.newGisData[index].data.length - 1
                  ],
                ],
              });
            }
          }
        );
      } else {
        this.newGisData[this.newGisData.length - 1].lineStart = JSON.stringify(
          this.newGisData[index].data[0]
        );
        this.newGisData[this.newGisData.length - 1].lineEnd = JSON.stringify(
          this.newGisData[index].data[this.newGisData[index].data.length - 1]
        );
        this.lineItemInfo = {
          name: this.activePointType.name,
          helixFactor: 2,
          sagFactor: 0,
          length: 0,
          adjustedLength: 0,
          costPriceExVatPerMetre: 0,
          costPriceExVat: 0,
          labour: 0,
          labourPerMetre: 0,
          labourChargedPerM: true,
        };
        this.newGisData.push({
          colour: this.activePointType.colour,
          name: null,
          type: "Line",
          waypoints: [],
          data: [],
        });
      }
    },
    async savePoints() {
      let obj = {};
      console.log(this.newGisData);
      if (this.activePointType.type == "Line" && this.newGisData.length > 0) {
        if (this.connectPoints && this.connectToPoint) {
          let points = this.newGisData[this.newGisData.length - 1].data;
          if (points && points[0] && !points[0].length > 1) {
            this.newGisData.pop();
          }
        }
        console.log(this.newGisData[this.newGisData.length - 1].data);
        let length = 0;
        try {
          length = google.maps.geometry.spherical.computeLength(
            this.newGisData[this.newGisData.length - 1].data
          );
        } catch (e) {
          length = 0;
        }
        this.lineItemInfo.length = Math.round(length * 100) / 100;
        let adjustments =
          Math.round(
            this.lineItemInfo.length *
              ((this.lineItemInfo.helixFactor + this.lineItemInfo.sagFactor) /
                100) *
              100
          ) / 100;
        this.lineItemInfo.adjustedLength =
          Math.round((this.lineItemInfo.length + adjustments) * 100) / 100;
        this.newGisData[this.newGisData.length - 1].isEditing = false;
        this.newGisData[this.newGisData.length - 1].name =
          this.lineItemInfo.name;
        this.newGisData[this.newGisData.length - 1].assetTag =
          this.lineItemInfo.assetTag;
        this.newGisData[this.newGisData.length - 1].helixFactor =
          this.lineItemInfo.helixFactor;
        this.newGisData[this.newGisData.length - 1].sagFactor =
          this.lineItemInfo.sagFactor;
        this.newGisData[this.newGisData.length - 1].installedBy =
          this.lineItemInfo.installedBy;
        this.newGisData[this.newGisData.length - 1].installedDate =
          this.lineItemInfo.installedDate;
        this.newGisData[this.newGisData.length - 1].gisPointTypeId =
          this.activePointType.id;
        this.newGisData[this.newGisData.length - 1].costPriceExVat =
          this.lineItemInfo.costPriceExVat;
        this.newGisData[this.newGisData.length - 1].costPriceExVatPerMetre =
          this.lineItemInfo.costPriceExVatPerMetre;
        this.newGisData[this.newGisData.length - 1].labour =
          this.lineItemInfo.labour;
        this.newGisData[this.newGisData.length - 1].labourPerMetre =
          this.lineItemInfo.labourPerMetre;
        this.newGisData[this.newGisData.length - 1].calculatedLength =
          this.lineItemInfo.adjustedLength;
        (this.newGisData[this.newGisData.length - 1].upstreamGISDataId =
          this.isInsideConnectionPoint && this.snapPointType
            ? this.snapPointType.id
            : this.newGisData[this.newGisData.length - 1].upstreamGISDataId
            ? this.newGisData[this.newGisData.length - 1].upstreamGISDataId
            : null),
          (this.newGisData[this.newGisData.length - 1].lineStart =
            JSON.stringify(
              this.newGisData[this.newGisData.length - 1].data[0]
            ));
        this.newGisData[this.newGisData.length - 1].lineEnd = JSON.stringify(
          this.newGisData[this.newGisData.length - 1].data[
            this.newGisData[this.newGisData.length - 1].data.length - 1
          ]
        );

        // this.newGisData[this.newGisData.length - 1].array = this.newGisData[
        //   this.newGisData.length - 1
        // ].data.toString();
        (this.newGisData[this.newGisData.length - 1].locationNetworkId = this
          .selectedNetwork
          ? this.selectedNetwork.id
          : null),
          (this.newGisData[this.newGisData.length - 1].locationNodeId =
            this.selectedNode);
        let batch = this.newGisData;
        for (let i = 0; i < this.newGisData.length; i++) {
          this.newGisData[i].array = [];
          this.newGisData[i].level = 0;
          for (let j = 0; j < this.newGisData[i].data.length; j++) {
            if (typeof this.newGisData[i].data[j].lat == "function") {
              this.newGisData[i].array.push({
                lat: this.newGisData[i].data[j].lat(),
                lng: this.newGisData[i].data[j].lng(),
              });
            } else {
              this.newGisData[i].array.push({
                lat: this.newGisData[i].data[j].lat,
                lng: this.newGisData[i].data[j].lng,
              });
            }
          }
          this.newGisData[i].array = JSON.stringify(this.newGisData[i].array);
        }
        console.log(this.newGisData);
        await Api()
          .post("/gisData", { batch: batch })
          .then((response) => {
            this.getGISData();
            this.text = "Successfully Saved!";
            this.snackbar = true;
            this.newGisData = [];
            this.lineItemInfo = {
              name: "",
              helixFactor: 2,
              sagFactor: 2,
              length: 0,
              adjustedLength: 0,
              labour: 0,
              labourPerMetre: 0,
              labourChargedPerM: true,
            };
            this.activePointType = {};
          });
      } else if (this.activePointType.type == "Point") {
        console.log(this.newGisData);
        let batch = await this.newGisData.map((x) => ({
          name: x.name,
          installedDate: x.installedDate,
          installedBy: x.installedBy,
          note: null,
          lat: x.position.lat,
          lng: x.position.lng,
          level: "0",
          gisPointTypeId: this.activePointType.id,
          costPriceExVat: this.markerItemInfo.costPriceExVat,
          labour: this.markerItemInfo.labour,
          level: x.level,
          upstreamGISDataId:
            this.isInsideConnectionPoint && x.upstreamGISDataId
              ? x.upstreamGISDataId
              : null,
          locationNetworkId: this.selectedNetwork
            ? this.selectedNetwork.id
            : null,
          locationNodeId: this.selectedNode,
        }));
        await Api()
          .post("/gisData", { batch: batch })
          .then((response) => {
            this.getGISData();
            this.text = "Successfully Saved!";
            this.snackbar = true;
            this.newGisData = [];
            this.markerItemInfo = {
              prefix: "",
              suffix: "",
              name: "",
              count: 0,
              installedDate: new Date().toISOString().substr(0, 10),
              installedBy: "",
              labour: 0,
              costPriceExVat: 0,
            };
            this.activePointType = {};
          });
      }
    },
    async getRoadSnapRoutes(origin, destination) {
      let routes = [];
      let routeService = await new google.maps.DirectionsService();
      await routeService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: google.maps.DirectionsTravelMode.DRIVING,
        },
        (result, status) => {
          if (status == google.maps.DirectionsStatus.OK) {
            routes = result.routes[0].overview_path;
            this.newGisData[this.newGisData.length - 1].data = routes;
          }
        }
      );
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    initDrawing() {
      this.$refs.mapRef.$mapPromise.then((map) => {
        const drawingManager = new google.maps.drawing.DrawingManager({
          drawingMode: google.maps.drawing.OverlayType.RECTANGLE,
          drawingControl: this.plottingImageOverlay,
          drawingControlOptions: {
            position: google.maps.ControlPosition.BOTTOM_CENTER,
            drawingModes: [
              // google.maps.drawing.OverlayType.MARKER,
              // google.maps.drawing.OverlayType.CIRCLE,
              // google.maps.drawing.OverlayType.POLYGON,
              // google.maps.drawing.OverlayType.POLYLINE,
              google.maps.drawing.OverlayType.RECTANGLE,
            ],
          },
          markerOptions: {
            icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
          },
          rectangleOptions: {
            fillColor: "#ffffff",
            fillOpacity: 0,
            strokeWeight: 1,
            clickable: false,
            editable: true,
            zIndex: 1,
          },
        });
        drawingManager.setMap(map);

        google.maps.event.addListener(
          drawingManager,
          "rectanglecomplete",
          async (rec) => {
            this.newImageOverlay.bounds = rec.bounds;
            await this.createOverlayImage(this.newImageOverlay);
            this.newImageOverlay = {};
            this.imageOverlayKey += 1;
            this.plottingImageOverlay = false;
            drawingManager.setMap(null);
          }
        );
      });
    },
    async plotElevation(elevations, status) {
      let result = elevations.map((x) => x.elevation);
      this.lineOfSightItemColors = [];
      result[0] += 10;
      let elevationData = await result.map((x, index) => [
        Math.round((this.lineOfSightItem.tower.distance / 256) * (index + 1)),
        x,
      ]);
      elevationData = await this.testData(elevationData);
      this.elevationData = [];

      let x1 = 0;
      let x2 = elevationData[0].data.length;
      let y1 = elevationData[1].data[0];
      let y2 = elevationData[1].data[1];

      let m = (y2 - y1) / (x2 - x1);
      let c = y2 - m * x2;
      let elevData = [];
      this.lineOfSightItem.result = true;

      for (let i = 0; i < elevationData[0].data.length; i++) {
        let losPoint = m * i + c;
        if (losPoint < elevationData[0].data[i][1]) {
          this.lineOfSightItem.result = false;
        }
      }

      this.elevationData.push({
        labels: elevationData[0].data.map((x) => x[0]),
        datasets: [
          {
            label: "LOS",
            data: elevData,
            backgroundColor: this.lineOfSightItem.result
              ? "#99cc33"
              : "#f5210a",
            fill: false,
            borderColor: this.lineOfSightItem.result ? "#99cc33" : "#f5210a",
            borderWidth: 0.3,
          },
          {
            label: "Elevation",
            data: elevationData[0].data.map((x) => x[1]),
            backgroundColor: this.pSBC(0.35, "#68b4f2"),
            borderColor: "#68b4f2",
            borderWidth: 0.3,
          },
        ],
      }),
        this.elevationData.push({
          title: {
            display: true,
            text: "Elevation",
          },
        });
      this.lineOfSightModal = true;
    },
    pSBC(p, c0, c1, l) {
      let r,
        g,
        b,
        P,
        f,
        t,
        h,
        i = parseInt,
        m = Math.round,
        a = typeof c1 == "string";
      if (
        typeof p != "number" ||
        p < -1 ||
        p > 1 ||
        typeof c0 != "string" ||
        (c0[0] != "r" && c0[0] != "#") ||
        (c1 && !a)
      )
        return null;
      if (!this.pSBCr)
        this.pSBCr = (d) => {
          let n = d.length,
            x = {};
          if (n > 9) {
            ([r, g, b, a] = d = d.split(",")), (n = d.length);
            if (n < 3 || n > 4) return null;
            (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
              (x.g = i(g)),
              (x.b = i(b)),
              (x.a = a ? parseFloat(a) : -1);
          } else {
            if (n == 8 || n == 6 || n < 4) return null;
            if (n < 6)
              d =
                "#" +
                d[1] +
                d[1] +
                d[2] +
                d[2] +
                d[3] +
                d[3] +
                (n > 4 ? d[4] + d[4] : "");
            d = i(d.slice(1), 16);
            if (n == 9 || n == 5)
              (x.r = (d >> 24) & 255),
                (x.g = (d >> 16) & 255),
                (x.b = (d >> 8) & 255),
                (x.a = m((d & 255) / 0.255) / 1000);
            else
              (x.r = d >> 16),
                (x.g = (d >> 8) & 255),
                (x.b = d & 255),
                (x.a = -1);
          }
          return x;
        };
      (h = c0.length > 9),
        (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
        (f = this.pSBCr(c0)),
        (P = p < 0),
        (t =
          c1 && c1 != "c"
            ? this.pSBCr(c1)
            : P
            ? { r: 0, g: 0, b: 0, a: -1 }
            : { r: 255, g: 255, b: 255, a: -1 }),
        (p = P ? p * -1 : p),
        (P = 1 - p);
      if (!f || !t) return null;
      if (l)
        (r = m(P * f.r + p * t.r)),
          (g = m(P * f.g + p * t.g)),
          (b = m(P * f.b + p * t.b));
      else
        (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
          (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
          (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
      (a = f.a),
        (t = t.a),
        (f = a >= 0 || t >= 0),
        (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
      if (h)
        return (
          "rgb" +
          (f ? "a(" : "(") +
          r +
          "," +
          g +
          "," +
          b +
          (f ? "," + m(a * 1000) / 1000 : "") +
          ")"
        );
      else
        return (
          "#" +
          (
            4294967296 +
            r * 16777216 +
            g * 65536 +
            b * 256 +
            (f ? m(a * 255) : 0)
          )
            .toString(16)
            .slice(1, f ? undefined : -2)
        );
    },
    initZoomChange() {
      this.$refs.mapRef.$mapPromise.then(async (map) => {
        google.maps.event.addListener(map, "zoom_changed", async () => {
          this.currentZoom = map.getZoom();
          // for(let i=0; i< this.markerArray.length;i++){
          //   this.markerArray.setVisible((this.currentZoom >= 13))
          // }
        });
        google.maps.event.addListener(map, "bounds_changed", async () => {
          this.bounds = map.getBounds();
          this.boundsChange += 1;
        });

        // google.maps.event.addListener(map, "rightclick", (event) => {
        //   console.log(event);
        // });
        let zoom = this.currentZoom;
        const moonMapType = new google.maps.ImageMapType({
          getTileUrl: (coord, zoom) => {
            const normalizedCoord = this.getNormalizedCoord(coord, zoom);

            if (!normalizedCoord) {
              return "";
            }

            const bound = Math.pow(2, zoom);
            return (
              "https://mw1.google.com/mw-planetary/lunar/lunarmaps_v1/clem_bw" +
              "/" +
              zoom +
              "/" +
              normalizedCoord.x +
              "/" +
              (bound - normalizedCoord.y - 1) +
              ".jpg"
            );
          },
          tileSize: new google.maps.Size(256, 256),
          maxZoom: 9,
          minZoom: 0,
          radius: 1738000,
          name: "Moon",
        });
        map.mapTypes.set("moon", moonMapType);
      });
    },
    getNormalizedCoord(coord, zoom) {
      const y = coord.y;
      let x = coord.x; // tile range in one direction range is dependent on zoom level
      // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc

      const tileRange = 1 << zoom; // don't repeat across y-axis (vertically)

      if (y < 0 || y >= tileRange) {
        return null;
      } // repeat across x-axis

      if (x < 0 || x >= tileRange) {
        x = ((x % tileRange) + tileRange) % tileRange;
      }

      return {
        x: x,
        y: y,
      };
    },

    withinBounds(marker) {
      return map.getBounds().contains(marker.getPosition());
    },

    initMapAutocomplete() {
      let geocoder = new google.maps.Geocoder();

      const input = document.getElementById("pac-input");
      const autocomplete = new google.maps.places.Autocomplete(input);
      autocomplete.setComponentRestrictions({
        country: ["za"],
      });

      google.maps.event.addListener(autocomplete, "place_changed", () => {
        let curPlace = autocomplete.getPlace();
        console.log(curPlace);
        this.placeInfoWindow = curPlace;
        this.showPlaceInfoWindow = true;
        this.center = curPlace.geometry.location;
        this.zoom = 18;
      });
    },

    // Cropping functions
    bind() {
      // Randomize cat photos, nothing special here.
      let url = this.images[Math.floor(Math.random() * 4)];

      // Just like what we did with .bind({...}) on
      // the mounted() function above.
      this.$refs.croppieRef.bind({
        url: url,
      });
    },
    // CALBACK USAGE
    crop() {
      // Here we are getting the result via callback function
      // and set the result to this.cropped which is being
      // used to display the result above.
      this.initDrawing();
      let options = {
        format: "jpeg",
        circle: false,
      };
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = output;
        this.overlayImage = output;
        this.newImageOverlay.img = output;
      });
      this.uploadImageOverlayModal = false;
      this.plottingImageOverlay = true;
    },
    result(output) {
      this.cropped = output;
    },
    update(val) {
      console.log(val);
    },
    rotate(rotationAngle) {
      // Rotates the image
      this.$refs.croppieRef.rotate(rotationAngle);
    },
    croppie(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      var reader = new FileReader();
      reader.onload = (e) => {
        this.newImageOverlay.img = e.target.result;
        this.$refs.croppieRef.bind({
          url: e.target.result,
        });
      };

      reader.readAsDataURL(files[0]);
    },
  },
};
</script>
<style scoped>
.crosshairCursor {
  cursor: "crosshair";
}
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
/* .uncompact-form {
  transform: scale(0.99);
  transform-origin: center;
} */
.cardBorder {
  border-top: 5px solid rgb(137, 207, 32) !important;
}
.normalBorder {
  border-top: 5px solid rgb(125, 126, 123) !important;
}
.text {
  display: block;
  width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.v-icon.outlined {
  margin: 1px;
  border: 1px solid currentColor;
  border-radius: 20%;
  height: 30px;
  width: 30px;
  background-color: white;
  z-index: 5;
}
.v-icon.selected {
  margin: 1px;
  border: 2px solid rgb(148, 216, 47);
  border-radius: 30%;
  height: 40px;
  width: 40px;
  background-color: white;
  z-index: 5;
}
#circle-card {
  border-radius: 50%;
  border: 5px solid rgb(136, 134, 134) !important;
}
#circle-card-sub {
  border-radius: 50%;

  min-height: 80px;
  min-width: 80px;
  max-height: 280px;
  max-width: 280px;
}
.circle-card-inner {
  border-radius: 50%;
  min-width: 20px;
  min-height: 20px;
  max-width: 75px;
  max-height: 75px;
}
.superscript {
  position: relative;
  top: -0.5em;
  font-size: 80%;
}
.gm-style-cc {
  display: none;
}
</style>
